import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import "react-multi-carousel/lib/styles.css";
import SwipeableViews from "react-swipeable-views";
import MyMap from "../components/MyMap";
import MyCarousel from "../components/MyCarousel";
import SlidingMenu from "../components/slidingMenu";
// import clamp from "lodash-es/clamp";
// import { useSprings, animated } from "react-spring";
// import { useGesture } from "react-use-gesture";

const Landing = (prop) => {
  const { texts, langHandler, globalState } = prop;
  const history = useHistory();
  ///

  const sectionsData = [
    {
      bgColor: "linear-gradient(119deg, #e08b14 -14%, #e08b14 100%)",
      color: "#e08b14",
      iconGradiant: "linear-gradient(to bottom, #e08b14 28%, #4b506b 98%)",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37"
          height="43"
          viewBox="0 0 37 43"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.187">
              <g>
                <path
                  d="M35.358.102L.358.102.358 41.102 29.765 41.102 29.765 12.804 35.358 12.804zM33.358 41.102L35.358 41.102 35.358 31.102 33.358 31.102"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M33.358 27.102L35.358 27.102 35.358 17.102 33.358 17.102M4.358 38.102V4.148h17.964v-.046h4.036v33.954h-.291v.046H4.358zm4.037-4.154h13.926V8.302H8.395v25.646z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M22.358 8.137v6.29l-5.086-6.29h5.086zm-5.115 25.93h5.086v-6.291l-5.086 6.29zM13.472 8.101l-5.086 6.29v-6.29h5.086zm-.029 26H8.358v-6.29l5.085 6.29zM14.857 11.102L20.358 20.602 14.857 30.102 9.358 20.602z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      svgRes: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="31"
          viewBox="0 0 26 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#727D93" fill-rule="nonzero">
              <path
                d="M363.482 801.508c.233 0 .422.19.422.422v9.033c0 .233-.189.422-.422.422h-3.555v19.701c0 .21-.153.384-.353.417l-.069.005h-20.912c-.233 0-.422-.189-.422-.422V801.93c0-.233.19-.422.422-.422zm0 22.045c.21 0 .384.153.417.354l.005.068v7.111c0 .21-.153.384-.353.417l-.069.005h-1.422c-.233 0-.422-.189-.422-.422 0-.21.153-.384.354-.416l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.354l-.006-.068c0-.21.153-.384.354-.417l.068-.005h1.422zm-.422-21.2h-24.045v28.31h20.068v-19.7c0-.21.153-.384.354-.416l.068-.006h3.555v-8.189zm-5.978 2c.21 0 .384.153.417.353l.005.069v24.145c0 .21-.153.384-.353.416l-.069.006h-.047l-.026.011-.032.01-.033.006-.069.006h-15.437c-.21 0-.384-.153-.417-.354l-.005-.068v-24.145c0-.21.153-.384.353-.417l.069-.005h12.614l.027-.012.032-.009.033-.007.068-.005h2.87zm-.422.844h-2.288l-.026.011-.032.01-.033.006-.069.006H341.86v23.3h14.8v-23.333zm-8.741 2c.132 0 .241.057.316.142h2.094c.06-.058.137-.099.227-.112l.065-.005h3.617c.21 0 .384.154.416.354l.006.069v4.473c0 .054-.01.103-.026.148v9.276l.005.068v4.473c0 .21-.153.384-.353.417l-.069.005H350.6c-.098 0-.185-.032-.253-.083h-2.165c-.059.053-.133.091-.22.104l-.064.004h-3.616c-.21 0-.384-.153-.416-.353l-.006-.069v-4.473c0-.054.01-.103.026-.148v-9.318l-.001-.008-.005-.068v-4.474c0-.21.153-.384.353-.416l.069-.006h3.617zm-3.189 15.663v2.717h2.195l-2.195-2.717zm5.784-14.677h-2.51l-3.274 4.05v3.885l3.809-6.577c.148-.255.496-.278.68-.07l.05.07 3.912 6.756c.076.13.076.292 0 .423l-3.912 6.755c-.162.281-.568.281-.73 0l-3.809-6.578v4.62l3.281 4.06h2.456l3.321-4.109v-9.236l-3.274-4.049zm3.274 14.626l-2.236 2.767h2.237v-2.767zm-4.884-12.214l-3.424 5.913 3.424 5.913 3.424-5.913-3.424-5.913zm14.578 3.002c.21 0 .384.153.417.354l.005.068v7.112c0 .21-.153.383-.353.416l-.069.006h-1.422c-.233 0-.422-.19-.422-.422 0-.21.153-.384.354-.417l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.353l-.006-.069c0-.21.153-.383.354-.416l.068-.006h1.422zm-9.693-5.414h-2.19l2.19 2.707v-2.707zm-6.87 0h-2.189v2.706l2.188-2.706z"
                transform="translate(-338 -801)"
              />
            </g>
          </g>
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="31"
          viewBox="0 0 26 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#E08B14" fill-rule="nonzero">
              <path
                d="M363.482 801.508c.233 0 .422.19.422.422v9.033c0 .233-.189.422-.422.422h-3.555v19.701c0 .21-.153.384-.353.417l-.069.005h-20.912c-.233 0-.422-.189-.422-.422V801.93c0-.233.19-.422.422-.422zm0 22.045c.21 0 .384.153.417.354l.005.068v7.111c0 .21-.153.384-.353.417l-.069.005h-1.422c-.233 0-.422-.189-.422-.422 0-.21.153-.384.354-.416l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.354l-.006-.068c0-.21.153-.384.354-.417l.068-.005h1.422zm-.422-21.2h-24.045v28.31h20.068v-19.7c0-.21.153-.384.354-.416l.068-.006h3.555v-8.189zm-5.978 2c.21 0 .384.153.417.353l.005.069v24.145c0 .21-.153.384-.353.416l-.069.006h-.047l-.026.011-.032.01-.033.006-.069.006h-15.437c-.21 0-.384-.153-.417-.354l-.005-.068v-24.145c0-.21.153-.384.353-.417l.069-.005h12.614l.027-.012.032-.009.033-.007.068-.005h2.87zm-.422.844h-2.288l-.026.011-.032.01-.033.006-.069.006H341.86v23.3h14.8v-23.333zm-8.741 2c.132 0 .241.057.316.142h2.094c.06-.058.137-.099.227-.112l.065-.005h3.617c.21 0 .384.154.416.354l.006.069v4.473c0 .054-.01.103-.026.148v9.276l.005.068v4.473c0 .21-.153.384-.353.417l-.069.005H350.6c-.098 0-.185-.032-.253-.083h-2.165c-.059.053-.133.091-.22.104l-.064.004h-3.616c-.21 0-.384-.153-.416-.353l-.006-.069v-4.473c0-.054.01-.103.026-.148v-9.318l-.001-.008-.005-.068v-4.474c0-.21.153-.384.353-.416l.069-.006h3.617zm-3.189 15.663v2.717h2.195l-2.195-2.717zm5.784-14.677h-2.51l-3.274 4.05v3.885l3.809-6.577c.148-.255.496-.278.68-.07l.05.07 3.912 6.756c.076.13.076.292 0 .423l-3.912 6.755c-.162.281-.568.281-.73 0l-3.809-6.578v4.62l3.281 4.06h2.456l3.321-4.109v-9.236l-3.274-4.049zm3.274 14.626l-2.236 2.767h2.237v-2.767zm-4.884-12.214l-3.424 5.913 3.424 5.913 3.424-5.913-3.424-5.913zm14.578 3.002c.21 0 .384.153.417.354l.005.068v7.112c0 .21-.153.383-.353.416l-.069.006h-1.422c-.233 0-.422-.19-.422-.422 0-.21.153-.384.354-.417l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.353l-.006-.069c0-.21.153-.383.354-.416l.068-.006h1.422zm-9.693-5.414h-2.19l2.19 2.707v-2.707zm-6.87 0h-2.189v2.706l2.188-2.706z"
                transform="translate(-338 -801)"
              />
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/carpet-mobile.png",
      boldText: texts.landingText,
      lightText: "",
    },
    {
      title: texts.encyclopedia,
      bgColor: "linear-gradient(119deg, #e08b14 -14%, #e08b14 100%)",
      color: "#e08b14",
      iconGradiant: "linear-gradient(to bottom, #e08b14 28%, #4b506b 98%)",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37"
          height="43"
          viewBox="0 0 37 43"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.187">
              <g>
                <path
                  d="M35.358.102L.358.102.358 41.102 29.765 41.102 29.765 12.804 35.358 12.804zM33.358 41.102L35.358 41.102 35.358 31.102 33.358 31.102"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M33.358 27.102L35.358 27.102 35.358 17.102 33.358 17.102M4.358 38.102V4.148h17.964v-.046h4.036v33.954h-.291v.046H4.358zm4.037-4.154h13.926V8.302H8.395v25.646z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M22.358 8.137v6.29l-5.086-6.29h5.086zm-5.115 25.93h5.086v-6.291l-5.086 6.29zM13.472 8.101l-5.086 6.29v-6.29h5.086zm-.029 26H8.358v-6.29l5.085 6.29zM14.857 11.102L20.358 20.602 14.857 30.102 9.358 20.602z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      svgRes: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="31"
          viewBox="0 0 26 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#727D93" fill-rule="nonzero">
              <path
                d="M363.482 801.508c.233 0 .422.19.422.422v9.033c0 .233-.189.422-.422.422h-3.555v19.701c0 .21-.153.384-.353.417l-.069.005h-20.912c-.233 0-.422-.189-.422-.422V801.93c0-.233.19-.422.422-.422zm0 22.045c.21 0 .384.153.417.354l.005.068v7.111c0 .21-.153.384-.353.417l-.069.005h-1.422c-.233 0-.422-.189-.422-.422 0-.21.153-.384.354-.416l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.354l-.006-.068c0-.21.153-.384.354-.417l.068-.005h1.422zm-.422-21.2h-24.045v28.31h20.068v-19.7c0-.21.153-.384.354-.416l.068-.006h3.555v-8.189zm-5.978 2c.21 0 .384.153.417.353l.005.069v24.145c0 .21-.153.384-.353.416l-.069.006h-.047l-.026.011-.032.01-.033.006-.069.006h-15.437c-.21 0-.384-.153-.417-.354l-.005-.068v-24.145c0-.21.153-.384.353-.417l.069-.005h12.614l.027-.012.032-.009.033-.007.068-.005h2.87zm-.422.844h-2.288l-.026.011-.032.01-.033.006-.069.006H341.86v23.3h14.8v-23.333zm-8.741 2c.132 0 .241.057.316.142h2.094c.06-.058.137-.099.227-.112l.065-.005h3.617c.21 0 .384.154.416.354l.006.069v4.473c0 .054-.01.103-.026.148v9.276l.005.068v4.473c0 .21-.153.384-.353.417l-.069.005H350.6c-.098 0-.185-.032-.253-.083h-2.165c-.059.053-.133.091-.22.104l-.064.004h-3.616c-.21 0-.384-.153-.416-.353l-.006-.069v-4.473c0-.054.01-.103.026-.148v-9.318l-.001-.008-.005-.068v-4.474c0-.21.153-.384.353-.416l.069-.006h3.617zm-3.189 15.663v2.717h2.195l-2.195-2.717zm5.784-14.677h-2.51l-3.274 4.05v3.885l3.809-6.577c.148-.255.496-.278.68-.07l.05.07 3.912 6.756c.076.13.076.292 0 .423l-3.912 6.755c-.162.281-.568.281-.73 0l-3.809-6.578v4.62l3.281 4.06h2.456l3.321-4.109v-9.236l-3.274-4.049zm3.274 14.626l-2.236 2.767h2.237v-2.767zm-4.884-12.214l-3.424 5.913 3.424 5.913 3.424-5.913-3.424-5.913zm14.578 3.002c.21 0 .384.153.417.354l.005.068v7.112c0 .21-.153.383-.353.416l-.069.006h-1.422c-.233 0-.422-.19-.422-.422 0-.21.153-.384.354-.417l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.353l-.006-.069c0-.21.153-.383.354-.416l.068-.006h1.422zm-9.693-5.414h-2.19l2.19 2.707v-2.707zm-6.87 0h-2.189v2.706l2.188-2.706z"
                transform="translate(-338 -801)"
              />
            </g>
          </g>
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="31"
          viewBox="0 0 26 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#E08B14" fill-rule="nonzero">
              <path
                d="M363.482 801.508c.233 0 .422.19.422.422v9.033c0 .233-.189.422-.422.422h-3.555v19.701c0 .21-.153.384-.353.417l-.069.005h-20.912c-.233 0-.422-.189-.422-.422V801.93c0-.233.19-.422.422-.422zm0 22.045c.21 0 .384.153.417.354l.005.068v7.111c0 .21-.153.384-.353.417l-.069.005h-1.422c-.233 0-.422-.189-.422-.422 0-.21.153-.384.354-.416l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.354l-.006-.068c0-.21.153-.384.354-.417l.068-.005h1.422zm-.422-21.2h-24.045v28.31h20.068v-19.7c0-.21.153-.384.354-.416l.068-.006h3.555v-8.189zm-5.978 2c.21 0 .384.153.417.353l.005.069v24.145c0 .21-.153.384-.353.416l-.069.006h-.047l-.026.011-.032.01-.033.006-.069.006h-15.437c-.21 0-.384-.153-.417-.354l-.005-.068v-24.145c0-.21.153-.384.353-.417l.069-.005h12.614l.027-.012.032-.009.033-.007.068-.005h2.87zm-.422.844h-2.288l-.026.011-.032.01-.033.006-.069.006H341.86v23.3h14.8v-23.333zm-8.741 2c.132 0 .241.057.316.142h2.094c.06-.058.137-.099.227-.112l.065-.005h3.617c.21 0 .384.154.416.354l.006.069v4.473c0 .054-.01.103-.026.148v9.276l.005.068v4.473c0 .21-.153.384-.353.417l-.069.005H350.6c-.098 0-.185-.032-.253-.083h-2.165c-.059.053-.133.091-.22.104l-.064.004h-3.616c-.21 0-.384-.153-.416-.353l-.006-.069v-4.473c0-.054.01-.103.026-.148v-9.318l-.001-.008-.005-.068v-4.474c0-.21.153-.384.353-.416l.069-.006h3.617zm-3.189 15.663v2.717h2.195l-2.195-2.717zm5.784-14.677h-2.51l-3.274 4.05v3.885l3.809-6.577c.148-.255.496-.278.68-.07l.05.07 3.912 6.756c.076.13.076.292 0 .423l-3.912 6.755c-.162.281-.568.281-.73 0l-3.809-6.578v4.62l3.281 4.06h2.456l3.321-4.109v-9.236l-3.274-4.049zm3.274 14.626l-2.236 2.767h2.237v-2.767zm-4.884-12.214l-3.424 5.913 3.424 5.913 3.424-5.913-3.424-5.913zm14.578 3.002c.21 0 .384.153.417.354l.005.068v7.112c0 .21-.153.383-.353.416l-.069.006h-1.422c-.233 0-.422-.19-.422-.422 0-.21.153-.384.354-.417l.068-.006h1v-6.267h-1c-.21 0-.384-.153-.416-.353l-.006-.069c0-.21.153-.383.354-.416l.068-.006h1.422zm-9.693-5.414h-2.19l2.19 2.707v-2.707zm-6.87 0h-2.189v2.706l2.188-2.706z"
                transform="translate(-338 -801)"
              />
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/daneshname-icon.png",
      boldText: texts.wikipediaBoldText,
      lightText: texts.wikipediaLightText,
      gif: "./static/gifs/01-daneshname.gif",
    },
    {
      title: texts.rugGenerate,
      bgColor: "linear-gradient(119deg, #c82d4a -14%, #c82d4a 100%)",
      color: "#c82d4a",
      iconGradiant: "linear-gradient(to bottom, #c82d4a 28%, #4b506b 105%)",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="49"
          height="30"
          viewBox="0 0 49 30"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#FFF">
              <path
                d="M789.605 794.824c.383-.353.988-.581 1.67-.581.681 0 1.287.228 1.669.581-.382.353-.988.581-1.669.581-.682 0-1.287-.228-1.67-.58zm12.424-22.15c.039.002.074.024.093.059.021.037.02.082-.002.117l-.044.07-.117.194c.249.009.469.132.611.318-.147.194-.38.32-.641.32-.113 0-.22-.024-.318-.066l-1.277 2.102c.251.008.473.131.615.318-.147.194-.379.32-.641.32-.114 0-.222-.024-.321-.067l-1.277 2.103c.252.007.476.13.618.319-.146.194-.379.319-.641.319-.115 0-.224-.025-.323-.068l-1.279 2.104c.254.006.479.13.623.319-.147.194-.38.319-.641.319-.117 0-.227-.025-.327-.07l-1.279 2.106c.255.005.482.129.626.319-.147.194-.379.32-.641.32-.117 0-.229-.026-.33-.072l-1.28 2.107c.257.004.485.128.63.32-.147.193-.379.318-.641.318-.118 0-.231-.025-.333-.072l-1.28 2.109c.258.002.488.126.634.318-.147.194-.38.32-.641.32-.12 0-.234-.027-.336-.074l-1.282 2.11c.26 0 .492.126.638.319-.147.193-.379.319-.641.319-.121 0-.236-.027-.339-.075l-1.283 2.11h.001c.262 0 .494.126.641.32-.147.194-.379.319-.641.319-.122 0-.238-.028-.342-.077l-.139.23c-.028.046-.078.074-.131.074h-17.558v-.009h-7.119c-3.68 0-6.674-2.994-6.674-6.673 0-1.319.397-2.541 1.059-3.577l.233-.334c1.214-1.666 3.167-2.763 5.382-2.763 2.944 0 5.339 2.395 5.339 5.339 0 2.944-2.395 5.339-5.339 5.339-2.208 0-4.004-1.796-4.004-4.004 0-2.208 1.796-4.004 4.004-4.004.18 0 .354.018.524.052.473.077 1.004.37 1.302.671.519.488.843 1.18.843 1.946 0 1.472-1.198 2.67-2.669 2.67-.737 0-1.335-.599-1.335-1.335 0-.737.599-1.335 1.335-1.335.22 0 .426-.11.551-.29l.041-.061c.23-.602-.186-1.145-.962-.958-1.297.18-2.3 1.297-2.3 2.644 0 1.471 1.198 2.67 2.67 2.67 2.208 0 4.004-1.797 4.004-4.005s-1.796-4.004-4.004-4.004c-2.945 0-5.339 2.394-5.339 5.339 0 2.944 2.394 5.338 5.339 5.338 2.59 0 4.816-1.499 5.921-3.661l.024.014 10.042-15.988c.195-.315.35-.647.477-.99.163-.436.58-.725 1.046-.725 1.352-.005 3.908-.005 3.908-.005h-.001 8.288-.001 8.651zm-17.671 17.56c.223.008.451.103.56.3.21.381.015.845-.161 1.18-.35.476-.27.39-.629.777-.425.343-.993.483-1.566.283-.267-.096-.531-.235-.818-.19-.336.054-.797.533-1.134.955-.077.09-.095.215-.046.323.049.107.157.176.275.177 1.365.01 4.706.014 6.199.017.462 0 .89-.239 1.131-.632 1.044-1.706 2.085-3.414 3.128-5.12l-.207.045c-.616.13-1.292.263-1.855.014-.432-.19-.487-.745-.054-1.293.326-.413.755-.74 1.035-1.186.211-.336-.445-.713-1.45-.37-.39.134-.743.392-.915.762-.247.53-.308 1.163-.704 1.602-.687.762-2.025.667-3.071.344l-.021-.007c-.165.182-.333.362-.498.544l-.079.089c-.413.478-.84.983-.933 1.604-.011.09.149.089.149.089.556-.05 1.054-.318 1.664-.307zm6.867 1.918c.185-.245.479-.404.81-.404.331 0 .625.159.811.404-.186.245-.48.403-.811.403-.331 0-.625-.158-.81-.403zm-9.856-9.726c.132.009.262.058.354.152.327.334.167.866.013 1.227-.257.6-.691 1.14-1.233 1.513-.242.167-.524.295-.822.297-.496.003-.941-.37-1.39-.314-.544.068-.885.584-1.141 1-.063.103-.122.208-.179.315-.058.11-.114.222-.167.335-.057.12-.043.263.038.37.08.106.213.16.345.137.065-.01.132-.022.198-.03.443-.063.922-.1 1.325.068.308.13.51.492.353.849-.057.13-.132.253-.217.369-.341.467-.858.81-1.125 1.316-.067.126-.042.283.102.363.091.05.189.084.29.105.038.008.075.014.113.019.049.006.098.01.147.01.723.019 1.493-.349 1.769-1 .254-.6.331-1.326.907-1.745.817-.593 1.96-.415 2.861-.13.59-.66 1.244-1.305 1.491-2.157.079-.275-.103-.195-.293-.17-.494.067-.959.301-1.455.296-.34-.004-.665-.198-.674-.623-.02-.905.738-1.736 1.39-2.228.253-.191.554-.342.877-.345.5-.003.948.376 1.4.313.51-.07.842-.545 1.088-.934.062-.099.121-.2.177-.303.166-.302.307-.616.434-.937l.034-.085c-.229.054-.46.106-.692.145-.129.021-.258.039-.387.05-.106.01-.213.015-.32.015-.083 0-.167-.002-.25-.009-.06-.004-.12-.01-.18-.02-.466-.065-.957-.378-.7-.966.175-.403.526-.704.849-1.03l.075-.075c.319-.336.718-.744.195-.934-.409-.15-.898-.069-1.293.07-.561.198-.898.71-1.114 1.423-.207.67-.655 1.282-1.465 1.466-.698.159-1.427.026-2.103-.191l-.009-.003c-.62.685-1.365 1.373-1.481 2.204-.005.033-.058.072.035.092.496.108 1.088-.287 1.767-.29h.063zm11.477 7.051c.185-.245.479-.403.81-.403.331 0 .625.158.81.403-.185.245-.479.404-.81.404-.331 0-.625-.159-.81-.404zm-2.059-9.405c-.619.01-1.236.128-1.844.27-.363 1.062-.78 2.182-1.781 2.732-.295.162-.646.196-.984.103-.344-.095-.668-.307-1.004-.253-.489.078-.871.512-1.192.92-.246.312-.457.66-.505 1.045-.014.11-.066.233.099.24.61.029 1.233-.445 1.913-.306.197.04.365.187.418.386.097.362-.136.707-.31 1.012-.06.104-.123.207-.188.309-.075.115-.153.229-.234.34-.238.327-.496.638-.762.943.876.238 1.937.313 2.439-.334.309-.4.339-.953.577-1.422.523-1.028 2.143-1.612 3.066-.926.228.17.365.457.257.785-.239.72-1.131 1.12-1.423 1.836-.144.356.813.244 1.473.14.279-.045.556-.102.832-.167l4.568-7.447-.089-.024c-.257-.068-.518-.12-.781-.144-.083-.007-.166-.012-.249-.014-.065-.002-.131-.001-.197.001-.057.003-.114.007-.17.013-.382.04-.778.18-1.021.491-.412.529-.429 1.306-.868 1.835-.732.88-2.49 1.095-2.99.274-.234-.385.096-.896.386-1.216.147-.164.308-.316.463-.472.213-.217.441-.441.542-.714.051-.137-.177-.232-.397-.236h-.044zm3.679 6.731c.186-.245.48-.403.811-.403.33 0 .624.158.81.403-.186.245-.48.404-.81.404-.331 0-.625-.159-.811-.404zm-24.588-18.638c.932-1.356 2.47-2.165 4.222-2.165.539 0 1.07.086 1.58.257l.183.061c1.63.544 2.85 1.861 3.265 3.526.326 1.302.107 2.704-.599 3.842l-7.862 12.516c-.056.09-.163.136-.267.115-.105-.02-.186-.102-.205-.207-.583-3.083-3.27-5.428-6.521-5.428-.914 0-1.79.159-2.608.443-.042.015-.088.001-.115-.034-.027-.035-.028-.084-.003-.12l8.93-12.806zm26.209 15.964c.185-.245.479-.403.81-.403.331 0 .625.158.811.403-.186.245-.48.404-.811.404-.331 0-.625-.159-.81-.404zm3.487-10.141c.095 0 .182.051.228.134.047.083.045.184-.005.265l-3.329 5.423-.035-.012c-.725-.228-1.516-.344-2.24-.104-.843.279-1.116 1.002-1.339 1.719-.21.635-.66 1.03-1.208 1.17-.369.096-.785.142-1.136-.001-.097-.04-.25-.097-.245-.227.003-.075.063-.151.066-.157.291-.462.734-.796 1.068-1.23.056-.074.107-.148.107-.148.22-.282.332-.678.131-.946-.373-.495-1.468-.309-2.327-.138l-.18.038.01-.027c.128-.329.272-.652.44-.963.056-.105.115-.209.179-.31.248-.399.582-.887 1.102-.962.325-.047.636.148.965.244.57.168 1.074-.053 1.463-.384.061-.053.071-.057.2-.185.379-.349.704-.764.891-1.243.121-.32.293-.848-.02-1.162-.11-.112-.274-.155-.433-.16-.379-.006-.745.121-1.109.226-.259.072-.752.105-.723-.036.061-.302.22-.573.396-.824h7.083zm-1.866 7.467c.185-.245.479-.404.81-.404.331 0 .625.159.81.404-.185.245-.479.403-.81.403-.331 0-.625-.158-.81-.403zm-5.772-7.467l-.014.026c-.165.29-.347.574-.339.884.01.385.384.553.694.547.627-.01 1.177-.393 1.699-.322.127.02.052.271.052.271-.055.356-.244.678-.465.967-.413.538-.982 1.1-1.569.941-.558-.151-1.153-.394-1.639-.13-1.009.546-1.425 1.673-1.788 2.735l-.102.024c-.616.138-1.239.276-1.85.245-.252-.013-.373-.176-.287-.332.316-.57.905-.91 1.233-1.447.258-.423.196-.891-.129-1.114-.718-.493-1.787-.25-2.488.28l-.049.04c-.532.387-.624 1.054-.86 1.641-.442 1.101-1.649 1.019-2.658.745 0 0 .556-.659.789-.985.076-.106.148-.214.218-.323.235-.372.556-.767.468-1.225-.054-.28-.312-.425-.577-.441l-.058-.002c-.359 0-.703.117-1.047.214-.351.096-.796.223-.771-.013.058-.476.288-.881.583-1.239.347-.42.742-.836 1.218-.852.405-.014.819.304 1.276.318.781.025 1.311-.665 1.71-1.332.044-.075.125-.121.212-.121h6.538zm7.392 4.793c.186-.245.48-.404.811-.404.33 0 .624.159.81.404-.186.245-.48.403-.81.403-.331 0-.625-.158-.811-.403zm1.621-2.674c.185-.245.479-.404.81-.404.331 0 .625.159.811.404-.186.245-.48.403-.811.403-.331 0-.625-.159-.81-.404zm1.621-2.676c.382-.353.988-.581 1.669-.581s1.287.228 1.669.581c-.382.353-.988.581-1.669.581s-1.287-.228-1.669-.58z"
                transform="translate(-757 -766)"
              />
            </g>
          </g>
        </svg>
      ),
      svgRes: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="51"
          height="30"
          viewBox="0 0 51 30"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#727D93">
              <path
                d="M281.758 831.407c.391-.36 1.008-.593 1.704-.593.695 0 1.313.233 1.703.593-.39.36-1.008.593-1.703.593-.696 0-1.313-.233-1.704-.593zm12.676-22.599c.04.003.075.026.095.061.021.037.02.083-.002.12l-.045.071-.12.198c.254.009.479.135.624.325-.15.197-.388.325-.654.325-.116 0-.225-.024-.325-.067l-1.303 2.145c.257.008.483.134.628.325-.15.198-.387.325-.654.325-.116 0-.227-.024-.328-.068l-1.302 2.146c.257.007.485.133.63.325-.149.198-.387.326-.654.326-.117 0-.228-.025-.33-.07l-1.304 2.147c.259.006.488.132.635.325-.15.198-.387.326-.654.326-.119 0-.231-.025-.333-.07l-1.305 2.147c.26.005.492.132.639.326-.15.197-.387.325-.654.325-.12 0-.234-.026-.337-.072l-1.306 2.15c.262.003.495.13.643.325-.15.198-.387.325-.654.325-.12 0-.236-.026-.34-.073l-1.306 2.15c.263.003.498.13.647.326-.15.198-.388.326-.654.326-.122 0-.239-.027-.343-.075l-1.308 2.152c.266 0 .502.129.651.325-.15.198-.386.326-.654.326-.123 0-.24-.027-.346-.077l-1.309 2.154h.002c.267 0 .504.128.653.326-.15.197-.386.325-.653.325-.125 0-.243-.028-.35-.078l-.141.235c-.029.046-.08.075-.134.075h-17.913v-.01h-7.263c-3.754 0-6.809-3.054-6.809-6.807 0-1.345.405-2.593 1.08-3.65l.238-.34c1.239-1.7 3.231-2.819 5.491-2.819 3.004 0 5.447 2.443 5.447 5.447s-2.443 5.447-5.447 5.447c-2.252 0-4.085-1.833-4.085-4.085 0-2.253 1.833-4.086 4.085-4.086.184 0 .361.02.535.054.482.079 1.024.377 1.328.685.53.497.86 1.203.86 1.985 0 1.501-1.222 2.723-2.723 2.723-.752 0-1.362-.61-1.362-1.361 0-.752.611-1.362 1.362-1.362.225 0 .435-.112.562-.297l.042-.061c.235-.615-.19-1.169-.981-.977-1.324.183-2.347 1.323-2.347 2.697 0 1.5 1.222 2.723 2.724 2.723 2.253 0 4.085-1.833 4.085-4.085 0-2.253-1.832-4.085-4.085-4.085-3.004 0-5.447 2.443-5.447 5.447 0 3.003 2.443 5.446 5.447 5.446 2.643 0 4.914-1.53 6.04-3.735l.025.015 10.245-16.313c.2-.32.358-.659.487-1.009.166-.445.592-.74 1.067-.74 1.38-.005 3.987-.005 3.987-.005h8.455-.001 8.826zm-18.029 17.916c.228.008.46.105.572.307.214.388.015.86-.165 1.203-.357.486-.275.399-.641.793-.434.35-1.013.492-1.598.288-.272-.097-.542-.24-.834-.193-.343.055-.814.544-1.157.973-.079.092-.097.22-.047.33.05.11.16.18.28.18 1.393.01 4.801.016 6.325.018.47.001.908-.243 1.153-.644 1.066-1.741 2.128-3.484 3.192-5.225l-.211.047c-.629.132-1.319.268-1.893.014-.44-.194-.497-.76-.055-1.32.333-.42.77-.754 1.056-1.21.215-.342-.454-.727-1.48-.376-.397.136-.757.4-.933.777-.252.541-.314 1.186-.718 1.635-.701.777-2.066.68-3.133.35l-.022-.007c-.168.186-.34.37-.508.555l-.08.09c-.422.488-.857 1.004-.952 1.637-.011.092.152.091.152.091.567-.05 1.075-.325 1.697-.313zm7.006 1.956c.189-.25.489-.411.827-.411.337 0 .637.161.827.411-.19.25-.49.412-.827.412-.338 0-.638-.162-.827-.412zm-10.055-9.922c.135.01.267.059.361.155.334.341.17.884.013 1.252-.262.613-.705 1.163-1.258 1.544-.246.17-.534.3-.838.302-.506.003-.96-.377-1.418-.32-.555.07-.903.596-1.164 1.02-.065.106-.125.213-.183.321-.06.113-.116.227-.17.343-.059.123-.044.268.038.377.082.108.218.163.352.14l.202-.032c.452-.063.941-.1 1.352.071.314.132.52.501.36.865-.058.134-.134.26-.221.377-.348.477-.875.826-1.148 1.343-.068.129-.043.289.104.37.093.052.193.086.296.108.039.008.077.014.115.019.05.006.1.01.15.01.738.019 1.524-.356 1.805-1.02.26-.612.338-1.353.925-1.78.834-.606 2-.424 2.92-.133.601-.673 1.268-1.332 1.52-2.2.081-.281-.105-.2-.298-.174-.504.068-.979.307-1.485.302-.347-.004-.678-.203-.687-.636-.02-.923.752-1.77 1.418-2.273.258-.195.565-.35.894-.352.51-.003.968.384 1.429.32.52-.073.859-.556 1.11-.953.063-.101.123-.204.18-.309.17-.309.313-.63.443-.956l.035-.088c-.234.056-.47.109-.706.149-.132.022-.264.04-.395.051-.108.01-.217.015-.327.016-.084 0-.17-.003-.255-.01-.06-.004-.122-.011-.183-.02-.476-.067-.977-.386-.714-.986.178-.411.536-.718.866-1.05l.076-.078c.326-.342.733-.758.2-.953-.418-.152-.917-.07-1.32.072-.572.202-.916.725-1.136 1.452-.212.683-.669 1.308-1.495 1.496-.712.161-1.456.026-2.146-.196l-.009-.003c-.632.7-1.392 1.401-1.51 2.249-.006.033-.06.074.035.094.506.11 1.11-.292 1.803-.297l.064.001zm11.709 7.194c.189-.25.489-.411.826-.411.338 0 .638.161.827.411-.189.25-.489.412-.827.412-.337 0-.637-.162-.826-.412zm-2.1-9.596c-.632.01-1.262.13-1.882.276-.37 1.084-.796 2.226-1.817 2.787-.3.165-.659.2-1.004.105-.35-.096-.681-.313-1.024-.258-.499.08-.889.522-1.216.939-.251.318-.466.673-.515 1.066-.015.113-.068.238.1.246.623.028 1.259-.455 1.952-.313.201.04.373.19.427.394.099.368-.139.72-.317 1.031-.06.107-.125.212-.191.316-.077.118-.156.234-.24.347-.242.334-.505.651-.776.962.893.243 1.976.32 2.488-.341.315-.407.346-.972.588-1.45.534-1.05 2.187-1.645 3.128-.945.233.172.373.466.263.801-.244.734-1.154 1.142-1.452 1.873-.147.363.83.249 1.503.142.284-.045.567-.103.849-.17l4.66-7.597-.09-.025c-.263-.069-.53-.121-.798-.146-.084-.008-.17-.013-.254-.015-.066-.002-.133-.001-.2.001-.059.003-.117.007-.174.013-.39.04-.794.183-1.042.501-.42.54-.437 1.333-.885 1.872-.747.898-2.54 1.117-3.05.28-.24-.393.097-.914.393-1.241.15-.167.314-.322.472-.482.218-.221.45-.45.553-.727.052-.14-.18-.238-.405-.242h-.045zm3.753 6.868c.19-.25.49-.412.827-.412.337 0 .637.162.827.412-.19.25-.49.412-.827.412-.338 0-.637-.162-.827-.412zm-25.085-19.015c.95-1.383 2.52-2.209 4.307-2.209.55 0 1.092.088 1.612.262l.187.062c1.663.555 2.907 1.9 3.33 3.597.333 1.329.11 2.76-.61 3.92l-8.021 12.77c-.058.091-.167.138-.273.117-.107-.02-.19-.105-.209-.212-.595-3.145-3.336-5.538-6.653-5.538-.932 0-1.826.163-2.66.453-.043.015-.09.001-.118-.035-.027-.036-.028-.085-.003-.123l9.11-13.064zm26.739 16.287c.188-.25.488-.412.826-.412.338 0 .638.162.827.412-.19.25-.49.411-.827.411-.338 0-.638-.161-.826-.411zm3.557-10.346c.097 0 .186.052.233.136.048.085.046.188-.005.27l-3.397 5.533-.035-.012c-.74-.232-1.547-.35-2.286-.106-.86.284-1.138 1.022-1.366 1.753-.214.649-.673 1.051-1.232 1.195-.377.097-.801.144-1.16-.002-.098-.04-.254-.099-.25-.232.004-.075.065-.154.068-.16.297-.47.749-.812 1.09-1.254.057-.076.109-.151.109-.151.224-.288.339-.692.134-.965-.381-.505-1.498-.315-2.374-.14l-.184.038.01-.028c.13-.336.278-.666.449-.983.057-.107.117-.213.183-.316.253-.407.593-.905 1.124-.981.331-.048.649.15.984.249.582.171 1.096-.055 1.493-.392.062-.054.072-.059.204-.19.387-.355.718-.778.91-1.267.122-.326.298-.865-.021-1.186-.113-.113-.28-.157-.442-.162-.387-.007-.76.123-1.132.23-.264.073-.767.107-.737-.037.062-.308.224-.585.404-.84h7.226zm-1.904 7.617c.19-.25.489-.411.827-.411.337 0 .637.161.826.411-.189.25-.489.412-.826.412-.338 0-.638-.162-.827-.412zm-5.888-7.617l-.015.026c-.168.295-.354.586-.346.902.01.393.392.564.709.558.64-.01 1.2-.4 1.733-.328.13.02.053.276.053.276-.056.363-.249.691-.474.986-.422.55-1.002 1.123-1.601.96-.57-.154-1.177-.402-1.672-.133-1.03.558-1.454 1.708-1.824 2.791l-.105.024c-.628.142-1.264.282-1.887.25-.257-.012-.38-.179-.293-.338.323-.582.924-.929 1.258-1.476.263-.432.2-.91-.131-1.137-.733-.503-1.824-.255-2.539.286l-.05.04c-.542.396-.636 1.076-.877 1.675-.451 1.124-1.682 1.04-2.712.76 0 0 .567-.672.805-1.005.078-.108.151-.218.222-.33.24-.38.568-.782.478-1.249-.055-.286-.318-.434-.589-.45l-.059-.002c-.366 0-.717.12-1.068.218-.358.098-.812.227-.787-.013.06-.486.294-.9.595-1.264.354-.43.757-.853 1.243-.87.413-.014.835.31 1.302.325.796.026 1.337-.678 1.744-1.359.045-.076.128-.123.216-.123h6.67zm7.541 4.89c.19-.25.49-.413.828-.413.336 0 .636.162.826.412-.19.25-.49.412-.826.412-.338 0-.638-.162-.828-.412zm1.654-2.73c.189-.25.489-.41.826-.41.338 0 .638.16.828.41-.19.25-.49.413-.828.413-.337 0-.637-.162-.826-.412zm1.654-2.729c.39-.36 1.008-.592 1.702-.592.695 0 1.313.232 1.703.592-.39.36-1.008.593-1.703.593-.694 0-1.313-.232-1.702-.593z"
                transform="translate(-248 -802)"
              />
            </g>
          </g>
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="51"
          height="30"
          viewBox="0 0 51 30"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#BC2222">
              <path
                d="M281.758 831.407c.391-.36 1.008-.593 1.704-.593.695 0 1.313.233 1.703.593-.39.36-1.008.593-1.703.593-.696 0-1.313-.233-1.704-.593zm12.676-22.599c.04.003.075.026.095.061.021.037.02.083-.002.12l-.045.071-.12.198c.254.009.479.135.624.325-.15.197-.388.325-.654.325-.116 0-.225-.024-.325-.067l-1.303 2.145c.257.008.483.134.628.325-.15.198-.387.325-.654.325-.116 0-.227-.024-.328-.068l-1.302 2.146c.257.007.485.133.63.325-.149.198-.387.326-.654.326-.117 0-.228-.025-.33-.07l-1.304 2.147c.259.006.488.132.635.325-.15.198-.387.326-.654.326-.119 0-.231-.025-.333-.07l-1.305 2.147c.26.005.492.132.639.326-.15.197-.387.325-.654.325-.12 0-.234-.026-.337-.072l-1.306 2.15c.262.003.495.13.643.325-.15.198-.387.325-.654.325-.12 0-.236-.026-.34-.073l-1.306 2.15c.263.003.498.13.647.326-.15.198-.388.326-.654.326-.122 0-.239-.027-.343-.075l-1.308 2.152c.266 0 .502.129.651.325-.15.198-.386.326-.654.326-.123 0-.24-.027-.346-.077l-1.309 2.154h.002c.267 0 .504.128.653.326-.15.197-.386.325-.653.325-.125 0-.243-.028-.35-.078l-.141.235c-.029.046-.08.075-.134.075h-17.913v-.01h-7.263c-3.754 0-6.809-3.054-6.809-6.807 0-1.345.405-2.593 1.08-3.65l.238-.34c1.239-1.7 3.231-2.819 5.491-2.819 3.004 0 5.447 2.443 5.447 5.447s-2.443 5.447-5.447 5.447c-2.252 0-4.085-1.833-4.085-4.085 0-2.253 1.833-4.086 4.085-4.086.184 0 .361.02.535.054.482.079 1.024.377 1.328.685.53.497.86 1.203.86 1.985 0 1.501-1.222 2.723-2.723 2.723-.752 0-1.362-.61-1.362-1.361 0-.752.611-1.362 1.362-1.362.225 0 .435-.112.562-.297l.042-.061c.235-.615-.19-1.169-.981-.977-1.324.183-2.347 1.323-2.347 2.697 0 1.5 1.222 2.723 2.724 2.723 2.253 0 4.085-1.833 4.085-4.085 0-2.253-1.832-4.085-4.085-4.085-3.004 0-5.447 2.443-5.447 5.447 0 3.003 2.443 5.446 5.447 5.446 2.643 0 4.914-1.53 6.04-3.735l.025.015 10.245-16.313c.2-.32.358-.659.487-1.009.166-.445.592-.74 1.067-.74 1.38-.005 3.987-.005 3.987-.005h8.455-.001 8.826zm-18.029 17.916c.228.008.46.105.572.307.214.388.015.86-.165 1.203-.357.486-.275.399-.641.793-.434.35-1.013.492-1.598.288-.272-.097-.542-.24-.834-.193-.343.055-.814.544-1.157.973-.079.092-.097.22-.047.33.05.11.16.18.28.18 1.393.01 4.801.016 6.325.018.47.001.908-.243 1.153-.644 1.066-1.741 2.128-3.484 3.192-5.225l-.211.047c-.629.132-1.319.268-1.893.014-.44-.194-.497-.76-.055-1.32.333-.42.77-.754 1.056-1.21.215-.342-.454-.727-1.48-.376-.397.136-.757.4-.933.777-.252.541-.314 1.186-.718 1.635-.701.777-2.066.68-3.133.35l-.022-.007c-.168.186-.34.37-.508.555l-.08.09c-.422.488-.857 1.004-.952 1.637-.011.092.152.091.152.091.567-.05 1.075-.325 1.697-.313zm7.006 1.956c.189-.25.489-.411.827-.411.337 0 .637.161.827.411-.19.25-.49.412-.827.412-.338 0-.638-.162-.827-.412zm-10.055-9.922c.135.01.267.059.361.155.334.341.17.884.013 1.252-.262.613-.705 1.163-1.258 1.544-.246.17-.534.3-.838.302-.506.003-.96-.377-1.418-.32-.555.07-.903.596-1.164 1.02-.065.106-.125.213-.183.321-.06.113-.116.227-.17.343-.059.123-.044.268.038.377.082.108.218.163.352.14l.202-.032c.452-.063.941-.1 1.352.071.314.132.52.501.36.865-.058.134-.134.26-.221.377-.348.477-.875.826-1.148 1.343-.068.129-.043.289.104.37.093.052.193.086.296.108.039.008.077.014.115.019.05.006.1.01.15.01.738.019 1.524-.356 1.805-1.02.26-.612.338-1.353.925-1.78.834-.606 2-.424 2.92-.133.601-.673 1.268-1.332 1.52-2.2.081-.281-.105-.2-.298-.174-.504.068-.979.307-1.485.302-.347-.004-.678-.203-.687-.636-.02-.923.752-1.77 1.418-2.273.258-.195.565-.35.894-.352.51-.003.968.384 1.429.32.52-.073.859-.556 1.11-.953.063-.101.123-.204.18-.309.17-.309.313-.63.443-.956l.035-.088c-.234.056-.47.109-.706.149-.132.022-.264.04-.395.051-.108.01-.217.015-.327.016-.084 0-.17-.003-.255-.01-.06-.004-.122-.011-.183-.02-.476-.067-.977-.386-.714-.986.178-.411.536-.718.866-1.05l.076-.078c.326-.342.733-.758.2-.953-.418-.152-.917-.07-1.32.072-.572.202-.916.725-1.136 1.452-.212.683-.669 1.308-1.495 1.496-.712.161-1.456.026-2.146-.196l-.009-.003c-.632.7-1.392 1.401-1.51 2.249-.006.033-.06.074.035.094.506.11 1.11-.292 1.803-.297l.064.001zm11.709 7.194c.189-.25.489-.411.826-.411.338 0 .638.161.827.411-.189.25-.489.412-.827.412-.337 0-.637-.162-.826-.412zm-2.1-9.596c-.632.01-1.262.13-1.882.276-.37 1.084-.796 2.226-1.817 2.787-.3.165-.659.2-1.004.105-.35-.096-.681-.313-1.024-.258-.499.08-.889.522-1.216.939-.251.318-.466.673-.515 1.066-.015.113-.068.238.1.246.623.028 1.259-.455 1.952-.313.201.04.373.19.427.394.099.368-.139.72-.317 1.031-.06.107-.125.212-.191.316-.077.118-.156.234-.24.347-.242.334-.505.651-.776.962.893.243 1.976.32 2.488-.341.315-.407.346-.972.588-1.45.534-1.05 2.187-1.645 3.128-.945.233.172.373.466.263.801-.244.734-1.154 1.142-1.452 1.873-.147.363.83.249 1.503.142.284-.045.567-.103.849-.17l4.66-7.597-.09-.025c-.263-.069-.53-.121-.798-.146-.084-.008-.17-.013-.254-.015-.066-.002-.133-.001-.2.001-.059.003-.117.007-.174.013-.39.04-.794.183-1.042.501-.42.54-.437 1.333-.885 1.872-.747.898-2.54 1.117-3.05.28-.24-.393.097-.914.393-1.241.15-.167.314-.322.472-.482.218-.221.45-.45.553-.727.052-.14-.18-.238-.405-.242h-.045zm3.753 6.868c.19-.25.49-.412.827-.412.337 0 .637.162.827.412-.19.25-.49.412-.827.412-.338 0-.637-.162-.827-.412zm-25.085-19.015c.95-1.383 2.52-2.209 4.307-2.209.55 0 1.092.088 1.612.262l.187.062c1.663.555 2.907 1.9 3.33 3.597.333 1.329.11 2.76-.61 3.92l-8.021 12.77c-.058.091-.167.138-.273.117-.107-.02-.19-.105-.209-.212-.595-3.145-3.336-5.538-6.653-5.538-.932 0-1.826.163-2.66.453-.043.015-.09.001-.118-.035-.027-.036-.028-.085-.003-.123l9.11-13.064zm26.739 16.287c.188-.25.488-.412.826-.412.338 0 .638.162.827.412-.19.25-.49.411-.827.411-.338 0-.638-.161-.826-.411zm3.557-10.346c.097 0 .186.052.233.136.048.085.046.188-.005.27l-3.397 5.533-.035-.012c-.74-.232-1.547-.35-2.286-.106-.86.284-1.138 1.022-1.366 1.753-.214.649-.673 1.051-1.232 1.195-.377.097-.801.144-1.16-.002-.098-.04-.254-.099-.25-.232.004-.075.065-.154.068-.16.297-.47.749-.812 1.09-1.254.057-.076.109-.151.109-.151.224-.288.339-.692.134-.965-.381-.505-1.498-.315-2.374-.14l-.184.038.01-.028c.13-.336.278-.666.449-.983.057-.107.117-.213.183-.316.253-.407.593-.905 1.124-.981.331-.048.649.15.984.249.582.171 1.096-.055 1.493-.392.062-.054.072-.059.204-.19.387-.355.718-.778.91-1.267.122-.326.298-.865-.021-1.186-.113-.113-.28-.157-.442-.162-.387-.007-.76.123-1.132.23-.264.073-.767.107-.737-.037.062-.308.224-.585.404-.84h7.226zm-1.904 7.617c.19-.25.489-.411.827-.411.337 0 .637.161.826.411-.189.25-.489.412-.826.412-.338 0-.638-.162-.827-.412zm-5.888-7.617l-.015.026c-.168.295-.354.586-.346.902.01.393.392.564.709.558.64-.01 1.2-.4 1.733-.328.13.02.053.276.053.276-.056.363-.249.691-.474.986-.422.55-1.002 1.123-1.601.96-.57-.154-1.177-.402-1.672-.133-1.03.558-1.454 1.708-1.824 2.791l-.105.024c-.628.142-1.264.282-1.887.25-.257-.012-.38-.179-.293-.338.323-.582.924-.929 1.258-1.476.263-.432.2-.91-.131-1.137-.733-.503-1.824-.255-2.539.286l-.05.04c-.542.396-.636 1.076-.877 1.675-.451 1.124-1.682 1.04-2.712.76 0 0 .567-.672.805-1.005.078-.108.151-.218.222-.33.24-.38.568-.782.478-1.249-.055-.286-.318-.434-.589-.45l-.059-.002c-.366 0-.717.12-1.068.218-.358.098-.812.227-.787-.013.06-.486.294-.9.595-1.264.354-.43.757-.853 1.243-.87.413-.014.835.31 1.302.325.796.026 1.337-.678 1.744-1.359.045-.076.128-.123.216-.123h6.67zm7.541 4.89c.19-.25.49-.413.828-.413.336 0 .636.162.826.412-.19.25-.49.412-.826.412-.338 0-.638-.162-.828-.412zm1.654-2.73c.189-.25.489-.41.826-.41.338 0 .638.16.828.41-.19.25-.49.413-.828.413-.337 0-.637-.162-.826-.412zm1.654-2.729c.39-.36 1.008-.592 1.702-.592.695 0 1.313.232 1.703.592-.39.36-1.008.593-1.703.593-.694 0-1.313-.232-1.702-.593z"
                transform="translate(-248 -802)"
              />
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/chideman-icon.png",
      boldText: texts.layOutBoldText,
      lightText: texts.layOutLightText,
      gif: "./static/gifs/02-chideman.gif",
    },
    {
      title: texts.vr,
      bgColor: "linear-gradient(119deg, #06b170 -14%, #06b170 100%)",
      color: "#06b170",
      iconGradiant: "linear-gradient(to bottom, #06b170 28%, #4b506b 98%)",
      svgRes: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="31"
          viewBox="0 0 32 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#727D93" fill-rule="nonzero">
              <path
                d="M177.59 827.678c.251 0 .46.166.495.382l.005.066v2.858h2.753c.247 0 .448.224.448.5 0 .25-.166.459-.382.494l-.066.006h-3.305c-.247 0-.448-.224-.448-.5l.002-.026-.002-.027v-3.305c0-.247.224-.448.5-.448zm30.73 0c.25 0 .458.166.494.382l.005.066v3.305c0 .145-.077.274-.197.356-.068.1-.171.172-.29.191l-.065.006h-3.305c-.247 0-.448-.224-.448-.5 0-.251.166-.46.382-.495l.066-.005h2.856l.001-2.858c0-.247.224-.448.5-.448zm-15.497-22.556c.098-.035.204-.034.301 0l10.655 3.829c.192.025.355.176.384.379l.005.065v14.079c0 .189-.12.357-.297.421l-1.07.382-9.748 3.492c-.136.05-.277.028-.387-.04l-10.732-3.834c-.178-.064-.297-.232-.297-.421v-14.067-.02c.001-.019.003-.038.007-.057 0-.006.002-.011.003-.017.003-.018.008-.036.014-.053l.01-.023c.005-.016.012-.032.02-.047.007-.008.012-.017.018-.026.007-.014.017-.027.027-.04l.017-.018c.012-.015.026-.028.04-.04l.017-.012c.035-.029.077-.052.125-.069l-.058.026c.017-.01.035-.017.054-.024l.004-.002zm10.448 4.92l-1.312.469-.009.007-.064.028-8.537 3.058v13.098l9.096-3.25.827-.295v-13.115zm-20.74 0v13.116l9.923 3.544v-13.116l-9.923-3.544zm19.632 1.672l.015.066.005.065v10.618c0 .166-.091.316-.233.393l-.064.029-6.847 2.453c-.271.097-.555-.082-.594-.356l-.005-.065v-10.619c0-.165.091-.315.233-.392l.064-.029 6.847-2.453c.249-.09.508.054.58.29zm-6.817 11.472v1.09l1.054-.377-1.054-.713zm5.941-5.503l-2.579 4.93c-.148.283-.535.324-.74.08l-2.59-3.096c-.017-.02-.031-.04-.044-.061v2.563l2.11 1.426 1.497-.536 2.346-3.268v-2.038zm-.014 3.592l-.835 1.163.835-.299v-.864zm-2.876-6.119l-2.142 4.095 1.97 2.354 2.142-4.095-1.97-2.354zm.776-1.92l-1.495.536-2.344 3.265v2.044l2.581-4.932c.133-.254.46-.314.673-.145l.067.065 2.591 3.096c.016.02.03.04.043.062l-.002-2.561-2.114-1.43zm-2.978 1.069l-.835.299v.864l.835-1.163zm5.092-1.81l-1.054.378 1.054.713v-1.092zm-8.316-6.476l-9.553 3.39 9.484 3.387 3.721-1.33 4.882-1.743.016-.01.063-.028.794-.286-9.407-3.38zm-12.128-4.14c.247 0 .448.224.448.5 0 .25-.166.459-.382.494l-.066.006h-2.753v2.753c0 .247-.224.447-.5.447-.25 0-.459-.166-.494-.381l-.006-.066v-3.306c0-.119.052-.227.137-.307.065-.07.15-.12.245-.135l.066-.005h3.305zm27.424 0h.052c.251 0 .46.165.495.381l.005.066v3.306c0 .247-.224.447-.5.447-.25 0-.459-.166-.494-.381l-.006-.066v-2.753h-2.857c-.247 0-.448-.224-.448-.5 0-.251.166-.46.382-.495l.066-.005h3.305z"
                transform="translate(-177 -801)"
              />
            </g>
          </g>
        </svg>
      ),
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="43"
          viewBox="0 0 45 43"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.243">
              <g>
                <path
                  d="M21.834 35.244v-19.52l12.265-4.395v-.027l2.756-.987v19.52l-.199.071v.027l-14.822 5.31zm2.757-3.376l9.508-3.407V13.717l-9.508 3.407v14.744z"
                  transform="translate(-587 -759) translate(588 760)"
                />
                <path
                  d="M34.099 13.737v3.567l-3.449-2.331 3.449-1.236zm-3.468 15.947l3.448-1.236v-3.567l-3.448 4.803zm-2.557-13.808l-3.449 4.803V17.11l3.449-1.235zm-.019 14.75l-3.449 1.236v-3.567l3.449 2.332zM29.345 17.204L32.943 21.503 29.345 28.381 25.747 24.082z"
                  transform="translate(-587 -759) translate(588 760)"
                />
                <path
                  d="M36.855 29.864L21.834 35.228 21.834 15.697 36.855 10.332zM21.834 35.228L6.813 29.864 6.813 10.332 21.834 15.697z"
                  transform="translate(-587 -759) translate(588 760)"
                />
                <path
                  d="M21.932 4.968L6.813 10.332 21.834 15.697 36.855 10.332zM.5.5L.5 5.09M.5.5L5.09.5M.5 40.913L.5 36.323M.5 40.913L5.09 40.913M43.168.5L43.168 5.09M43.168.5L38.579.5M43.168 40.913L43.168 36.323M43.168 40.913L38.579 40.913"
                  transform="translate(-587 -759) translate(588 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="31"
          viewBox="0 0 32 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#06B170" fill-rule="nonzero">
              <path
                d="M177.59 827.678c.251 0 .46.166.495.382l.005.066v2.858h2.753c.247 0 .448.224.448.5 0 .25-.166.459-.382.494l-.066.006h-3.305c-.247 0-.448-.224-.448-.5l.002-.026-.002-.027v-3.305c0-.247.224-.448.5-.448zm30.73 0c.25 0 .458.166.494.382l.005.066v3.305c0 .145-.077.274-.197.356-.068.1-.171.172-.29.191l-.065.006h-3.305c-.247 0-.448-.224-.448-.5 0-.251.166-.46.382-.495l.066-.005h2.856l.001-2.858c0-.247.224-.448.5-.448zm-15.497-22.556c.098-.035.204-.034.301 0l10.655 3.829c.192.025.355.176.384.379l.005.065v14.079c0 .189-.12.357-.297.421l-1.07.382-9.748 3.492c-.136.05-.277.028-.387-.04l-10.732-3.834c-.178-.064-.297-.232-.297-.421v-14.067-.02c.001-.019.003-.038.007-.057 0-.006.002-.011.003-.017.003-.018.008-.036.014-.053l.01-.023c.005-.016.012-.032.02-.047.007-.008.012-.017.018-.026.007-.014.017-.027.027-.04l.017-.018c.012-.015.026-.028.04-.04l.017-.012c.035-.029.077-.052.125-.069l-.058.026c.017-.01.035-.017.054-.024l.004-.002zm10.448 4.92l-1.312.469-.009.007-.064.028-8.537 3.058v13.098l9.096-3.25.827-.295v-13.115zm-20.74 0v13.116l9.923 3.544v-13.116l-9.923-3.544zm19.632 1.672l.015.066.005.065v10.618c0 .166-.091.316-.233.393l-.064.029-6.847 2.453c-.271.097-.555-.082-.594-.356l-.005-.065v-10.619c0-.165.091-.315.233-.392l.064-.029 6.847-2.453c.249-.09.508.054.58.29zm-6.817 11.472v1.09l1.054-.377-1.054-.713zm5.941-5.503l-2.579 4.93c-.148.283-.535.324-.74.08l-2.59-3.096c-.017-.02-.031-.04-.044-.061v2.563l2.11 1.426 1.497-.536 2.346-3.268v-2.038zm-.014 3.592l-.835 1.163.835-.299v-.864zm-2.876-6.119l-2.142 4.095 1.97 2.354 2.142-4.095-1.97-2.354zm.776-1.92l-1.495.536-2.344 3.265v2.044l2.581-4.932c.133-.254.46-.314.673-.145l.067.065 2.591 3.096c.016.02.03.04.043.062l-.002-2.561-2.114-1.43zm-2.978 1.069l-.835.299v.864l.835-1.163zm5.092-1.81l-1.054.378 1.054.713v-1.092zm-8.316-6.476l-9.553 3.39 9.484 3.387 3.721-1.33 4.882-1.743.016-.01.063-.028.794-.286-9.407-3.38zm-12.128-4.14c.247 0 .448.224.448.5 0 .25-.166.459-.382.494l-.066.006h-2.753v2.753c0 .247-.224.447-.5.447-.25 0-.459-.166-.494-.381l-.006-.066v-3.306c0-.119.052-.227.137-.307.065-.07.15-.12.245-.135l.066-.005h3.305zm27.424 0h.052c.251 0 .46.165.495.381l.005.066v3.306c0 .247-.224.447-.5.447-.25 0-.459-.166-.494-.381l-.006-.066v-2.753h-2.857c-.247 0-.448-.224-.448-.5 0-.251.166-.46.382-.495l.066-.005h3.305z"
                transform="translate(-177 -801)"
              />
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/vagheiat-icon.png",
      boldText: texts.VRBoldText,
      lightText: texts.VRLightText,
      gif: "./static/gifs/03-Ar.gif",
    },
    {
      title: texts.buy,
      bgColor: "linear-gradient(119deg, #146bf0 -14%, #146bf0 100%)",
      color: "#146bf0",
      iconGradiant: "linear-gradient(to bottom, #1c7de1 28%, #4b506b 98%)",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="44"
          viewBox="0 0 27 44"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.179">
              <g>
                <path
                  d="M3.711 40.38V12.416h15.513v-.038h3.487v27.962h-.251v.038H3.71zm3.487-3.421h12.027V15.838H7.198v21.12z"
                  transform="translate(-437 -758) translate(437 759)"
                />
                <path
                  d="M19.711 15.408v5.08l-4.36-5.08h4.36zM15.327 36.35h4.36V31.27l-4.36 5.08zm-3.232-20.972l-4.36 5.081v-5.08h4.36zm-.024 21H7.71V31.3l4.36 5.08zM13.21 18.379L17.711 26.379 13.21 34.379 8.711 26.379zM20.711 10.38V7.481c0-3.731-2.738-7.103-6.334-7.103h-.114c-3.595 0-6.552 3.372-6.552 7.103v2.897"
                  transform="translate(-437 -758) translate(437 759)"
                />
                <path
                  d="M25.711 38.176L25.711 42.379 0.711 42.379 0.711 9.379 25.711 9.379 25.711 39.293"
                  transform="translate(-437 -758) translate(437 759)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      svgRes: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="31"
          viewBox="0 0 19 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#727D93" fill-rule="nonzero">
              <path
                d="M128.331 800.79c2.622 0 4.725 2.367 4.808 5.172l.003.172v.908h3.759c.203 0 .372.15.404.344l.005.066v22.928c0 .204-.148.372-.343.404l-.066.006h-17.37c-.203 0-.372-.149-.404-.344l-.006-.066v-22.928c0-.203.149-.372.344-.404l.066-.005 3.758-.001.001-.908c0-2.793 2.175-5.245 4.801-5.341l.24-.003zm8.16 7.071h-3.35v.286c0 .226-.183.41-.41.41-.203 0-.372-.149-.403-.344l-.006-.066v-.286h-8.213v.286c0 .226-.183.41-.41.41-.203 0-.372-.149-.404-.344l-.005-.066v-.286h-3.35v22.109h16.55V807.86zm-1.675 1.266c.204 0 .373.148.405.343l.005.067v19.427c0 .203-.149.372-.343.404l-.067.006-.032-.001-.013.006-.031.01-.032.006-.066.005h-13.027c-.203 0-.372-.149-.404-.343l-.005-.067v-19.427c0-.204.148-.373.343-.404l.066-.006h10.635l.014-.005.031-.01.032-.006.067-.005h2.422zm-.41.819h-1.87l-.013.006-.03.009-.033.006-.066.006-10.37-.001v18.608h12.382v-18.634zm-2.012 1.584c.204 0 .373.149.405.343l.005.067v14.674c0 .203-.149.372-.343.404l-.067.005c-.032.011-.06.02-.09.024l-.066.005h-2.78c-.055 0-.106-.01-.152-.029l-2.475.001c-.028.011-.057.02-.089.024l-.062.004h-2.78c-.203 0-.372-.148-.404-.343l-.005-.066v-3.474c0-.13.054-.235.136-.307v-7.03c-.067-.059-.116-.14-.131-.24l-.005-.066v-3.474c0-.16.092-.298.226-.366.061-.078.151-.134.255-.15l.066-.006h8.356zm-7.948 12.978l.001 1.695h1.355l-1.356-1.695zm4.725-12.16h-2.205l-2.52 3.15v7.698l2.406 3.007h2.433l2.633-3.29c.02-.026.042-.048.066-.067v-6.998l-.02-.017-.046-.049-2.747-3.433zm2.657 11.989l-1.494 1.866h1.493l.001-1.866zm-3.97-10.833c.157-.278.558-.278.715 0l3.126 5.559c.07.124.07.277 0 .401l-3.126 5.559c-.157.278-.558.278-.715 0l-3.126-5.559c-.07-.124-.07-.277 0-.401zm.357 1.037l-2.656 4.722 2.656 4.723 2.657-4.723-2.657-4.722zm3.613-2.08h-1.517l1.517 1.897v-1.897zm-6 0h-1.382v1.726l1.381-1.726zm2.503-10.852h-.079c-2.177 0-4.057 2.018-4.14 4.365l-.003.16v.908h8.212l.001-.908c0-2.397-1.717-4.433-3.845-4.522l-.146-.003z"
                transform="translate(-119 -800)"
              />
            </g>
          </g>
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="31"
          viewBox="0 0 19 31"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#146BF0" fill-rule="nonzero">
              <path
                d="M128.331 800.79c2.622 0 4.725 2.367 4.808 5.172l.003.172v.908h3.759c.203 0 .372.15.404.344l.005.066v22.928c0 .204-.148.372-.343.404l-.066.006h-17.37c-.203 0-.372-.149-.404-.344l-.006-.066v-22.928c0-.203.149-.372.344-.404l.066-.005 3.758-.001.001-.908c0-2.793 2.175-5.245 4.801-5.341l.24-.003zm8.16 7.071h-3.35v.286c0 .226-.183.41-.41.41-.203 0-.372-.149-.403-.344l-.006-.066v-.286h-8.213v.286c0 .226-.183.41-.41.41-.203 0-.372-.149-.404-.344l-.005-.066v-.286h-3.35v22.109h16.55V807.86zm-1.675 1.266c.204 0 .373.148.405.343l.005.067v19.427c0 .203-.149.372-.343.404l-.067.006-.032-.001-.013.006-.031.01-.032.006-.066.005h-13.027c-.203 0-.372-.149-.404-.343l-.005-.067v-19.427c0-.204.148-.373.343-.404l.066-.006h10.635l.014-.005.031-.01.032-.006.067-.005h2.422zm-.41.819h-1.87l-.013.006-.03.009-.033.006-.066.006-10.37-.001v18.608h12.382v-18.634zm-2.012 1.584c.204 0 .373.149.405.343l.005.067v14.674c0 .203-.149.372-.343.404l-.067.005c-.032.011-.06.02-.09.024l-.066.005h-2.78c-.055 0-.106-.01-.152-.029l-2.475.001c-.028.011-.057.02-.089.024l-.062.004h-2.78c-.203 0-.372-.148-.404-.343l-.005-.066v-3.474c0-.13.054-.235.136-.307v-7.03c-.067-.059-.116-.14-.131-.24l-.005-.066v-3.474c0-.16.092-.298.226-.366.061-.078.151-.134.255-.15l.066-.006h8.356zm-7.948 12.978l.001 1.695h1.355l-1.356-1.695zm4.725-12.16h-2.205l-2.52 3.15v7.698l2.406 3.007h2.433l2.633-3.29c.02-.026.042-.048.066-.067v-6.998l-.02-.017-.046-.049-2.747-3.433zm2.657 11.989l-1.494 1.866h1.493l.001-1.866zm-3.97-10.833c.157-.278.558-.278.715 0l3.126 5.559c.07.124.07.277 0 .401l-3.126 5.559c-.157.278-.558.278-.715 0l-3.126-5.559c-.07-.124-.07-.277 0-.401zm.357 1.037l-2.656 4.722 2.656 4.723 2.657-4.723-2.657-4.722zm3.613-2.08h-1.517l1.517 1.897v-1.897zm-6 0h-1.382v1.726l1.381-1.726zm2.503-10.852h-.079c-2.177 0-4.057 2.018-4.14 4.365l-.003.16v.908h8.212l.001-.908c0-2.397-1.717-4.433-3.845-4.522l-.146-.003z"
                transform="translate(-119 -800)"
              />
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/kharid-icon.png",
      boldText: texts.shoppingBoldText,
      lightText: texts.shoppingLightText,
      gif: "./static/gifs/04-shop.gif",
    },
    {
      title: texts.insuranceAndServices,
      bgColor: "linear-gradient(119deg, #5b32d9 -14%, #5b32d9 100%)",
      color: "#5b32d9",
      iconGradiant: "linear-gradient(to bottom, #6e44f2 28%, #4b506b 98%)",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="41"
          viewBox="0 0 36 41"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#FFF">
              <g>
                <path
                  d="M4.51 12.954c1.974 0 3.647 1.274 4.26 3.046h.498c.613-1.772 2.285-3.046 4.258-3.046 1.977 0 3.65 1.274 4.262 3.046h.327c.61-1.772 2.281-3.046 4.258-3.046 1.974 0 3.646 1.274 4.258 3.046h.5c.612-1.772 2.287-3.046 4.258-3.046 1.976 0 3.649 1.274 4.258 3.046H36c0-8.835-8.056-16-17.998-16C8.059 0 0 7.165 0 16h.253c.609-1.772 2.281-3.046 4.258-3.046zM7 17.455c.436.23.83.53 1.168.883v21.506h20.664V18.359c.337-.357.731-.66 1.168-.893v22.912c-.048.659-.71.599-.71.599-.08.017-.08.017-.164.023H7.584c-.454-.032-.553-.154-.584-.578V17.455zM13.165 17l-.99 1.17v12.128l4.723 5.581h3.17l4.758-5.621V18.144l-.968-1.143c.807.15 1.539.51 2.136 1.021v18.435c-.032.45-.156.548-.584.578H11.59c-.453-.032-.553-.154-.584-.578V18.038c.602-.52 1.342-.886 2.159-1.038zm-.968 18.88h3.177l-3.177-3.755v3.754zm9.423-.034h3.177v-3.754l-3.177 3.754zm-5.265-18.287c.34.201.653.445.929.724l-3.344 5.935 4.56 8.091 4.56-8.091-3.337-5.922c.275-.28.587-.526.927-.728l3.59 6.368c.133.273.126.307 0 .563l-5.23 9.279c-.234.366-.783.37-1.02 0l-5.23-9.279c-.133-.272-.125-.306 0-.563l3.595-6.377z"
                  transform="translate(-276 -760) translate(276 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      svgRes: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="30"
          viewBox="0 0 27 30"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#727D93">
              <path
                d="M58.122 814.772c.32.169.608.388.855.646v15.736h15.12v-15.72c.246-.262.535-.483.854-.654v16.765c-.035.482-.519.438-.519.438-.06.013-.06.013-.12.017H58.549c-.332-.024-.405-.113-.427-.423v-16.805zm12.335-.332c.59.11 1.126.373 1.563.747v13.489c-.024.329-.114.4-.427.423H61.48c-.332-.024-.405-.113-.428-.423v-13.477c.44-.38.982-.65 1.58-.76l-.725.856v8.875l3.456 4.083h2.32l3.481-4.113v-8.864l-.708-.836zm-5.49.408c.25.147.478.326.68.53L63.2 819.72l3.337 5.921 3.337-5.92-2.442-4.333c.2-.206.429-.385.678-.534l2.626 4.66c.098.2.093.224 0 .412l-3.826 6.79c-.172.267-.573.27-.747 0l-3.826-6.79c-.098-.2-.092-.224 0-.412l2.63-4.666zM66.172 802c7.275 0 13.17 5.242 13.17 11.707h-.259c-.446-1.296-1.67-2.228-3.116-2.228-1.441 0-2.667.932-3.115 2.228h-.366c-.448-1.296-1.671-2.228-3.115-2.228-1.447 0-2.67.932-3.116 2.228h-.24c-.448-1.296-1.671-2.228-3.118-2.228-1.444 0-2.667.932-3.115 2.228h-.366c-.448-1.296-1.671-2.228-3.115-2.228-1.447 0-2.67.932-3.116 2.228H53C53 807.242 58.897 802 66.172 802z"
                transform="translate(-53 -802)"
              />
            </g>
          </g>
        </svg>
      ),
      activeSvg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="30"
          viewBox="0 0 27 30"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#5B32D9">
              <path
                d="M58.122 814.772c.32.169.608.388.855.646v15.736h15.12v-15.72c.246-.262.535-.483.854-.654v16.765c-.035.482-.519.438-.519.438-.06.013-.06.013-.12.017H58.549c-.332-.024-.405-.113-.427-.423v-16.805zm12.335-.332c.59.11 1.126.373 1.563.747v13.489c-.024.329-.114.4-.427.423H61.48c-.332-.024-.405-.113-.428-.423v-13.477c.44-.38.982-.65 1.58-.76l-.725.856v8.875l3.456 4.083h2.32l3.481-4.113v-8.864l-.708-.836zm-5.49.408c.25.147.478.326.68.53L63.2 819.72l3.337 5.921 3.337-5.92-2.442-4.333c.2-.206.429-.385.678-.534l2.626 4.66c.098.2.093.224 0 .412l-3.826 6.79c-.172.267-.573.27-.747 0l-3.826-6.79c-.098-.2-.092-.224 0-.412l2.63-4.666zM66.172 802c7.275 0 13.17 5.242 13.17 11.707h-.259c-.446-1.296-1.67-2.228-3.116-2.228-1.441 0-2.667.932-3.115 2.228h-.366c-.448-1.296-1.671-2.228-3.115-2.228-1.447 0-2.67.932-3.116 2.228h-.24c-.448-1.296-1.671-2.228-3.118-2.228-1.444 0-2.667.932-3.115 2.228h-.366c-.448-1.296-1.671-2.228-3.115-2.228-1.447 0-2.67.932-3.116 2.228H53C53 807.242 58.897 802 66.172 802z"
                transform="translate(-53 -802)"
              />
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/bime-icon.png",
      // img: "./static/img/kharid-icon.png",
      boldText: texts.insuranceBoldText,
      lightText: texts.insuranceLightText,
      gif: "./static/gifs/05-bime.gif",
    },
  ];

  const [activeSection, setActiveSection] = useState({ title: undefined });
  const [activeTab, setActiveTab] = useState(0);
  const [beforeTab, setBeforeTab] = useState(0);
  const [contactUs, setContactUs] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openSwitchLang, setOpenSwitchLang] = useState(false);
  const [activeLang, setActiveLang] = useState({});
  const [langFlag, setLangFlag] = useState(false);

  const btnHandler = (i) => {
    if (i === 1) {
      window.location = "https://Shop.ghalichin.com/wiki";
    }
    if (i === 2) {
      history.push("/generator");
    }
    if (i === 3) {
      history.push("/room");
    }
    if (i === 4) {
      window.location = "https://shop.ghalichin.com/";
    }
    if (i === 5) {
      history.push("/insurance");
    }
  };

  const languagesList = [
    {
      abbreviation: "FA",
      title: "Persian",
      key: "fa",
    },
    {
      abbreviation: "EN",
      title: "English",
      key: "en",
    },
    {
      abbreviation: "AR",
      title: "Arabic",
      key: "ar",
    },
    {
      abbreviation: "DU",
      title: "German",
      key: "du",
    },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
    setActiveLang(
      languagesList?.filter((item) => item?.key === globalState.language)[0]
    );
  }, []);

  const myAnimation = (index, beforeIndex, section, flag) => {
    if (flag) {
      document.getElementById("movingContainer").style.background =
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%)";
      document.getElementById("movingContainer").style.transition = "all 1s";
      setContactUs(true);
      setActiveSection(section);
      setBeforeTab(0);
      setActiveTab(0);
    } else {
      setContactUs(false);
      if (beforeIndex >= 0 && index >= 0) {
        setTimeout(() => {
          document.getElementById(`tabText${beforeIndex}`).style.opacity = 0.2;

          document.getElementById(`tabText${beforeIndex}`).style.transition =
            "all 0.5s ease-in-out";

          setTimeout(() => {
            document.getElementById(`tabText${beforeIndex}`).style.display =
              "none";
            document.getElementById(
              `tabText${index - 1 >= 0 ? index - 1 : 0}`
            ).style.display = "flex";
            setTimeout(() => {
              document.getElementById(
                `tabText${index - 1 >= 0 ? index - 1 : 0}`
              ).style.opacity = 1;
              document.getElementById(
                `tabText${index - 1 >= 0 ? index - 1 : 0}`
              ).style.transition = "opacity 0.5s ease-in";
            }, 100);
          }, 300);
        }, 100);
      }

      let itemWidth =
        ((document?.getElementById("sliderBottomIconsBefore")?.offsetWidth -
          100) /
          5) *
        1;
      if (index > 0) {
        document.getElementById("movingContainer").style.transform =
          globalState.themeDirection === "ltr"
            ? `translateX(${+itemWidth * (index - 2) + 0.1 * itemWidth}px)`
            : `translateX(${-itemWidth * (index - 2) - 0.1 * itemWidth}px)`;

        document.getElementById("movingContainer").style.background = `${
          sectionsData[index - 1].iconGradiant
        }`;
        document.getElementById("movingContainer").style.transition =
          "all 0.5s";
      } else if (index === 0) {
        document.getElementById("movingContainer").style.transform =
          globalState.themeDirection === "ltr"
            ? `translateX(${+itemWidth * (index - 1)}px)`
            : `translateX(${-itemWidth * (index - 1)}px)`;
        document.getElementById("movingContainer").style.background =
          "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%)";
        document.getElementById("movingContainer").style.transition = "all 1s";
      }
      setActiveSection(section);
      setBeforeTab(beforeIndex);
      setActiveTab(index - 1 >= 0 ? index - 1 : 0);
    }
  };
  // const params = new URLSearchParams(window.location.search);
  function Outside(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          openSwitchLang &&
          !ref.current.contains(event.target)
        ) {
          setOpenSwitchLang(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, openSwitchLang]);
  }

  useEffect(() => {
    myAnimation(0, activeTab, { title: undefined }, false);
  }, [activeLang]);
  const wrapperRef2 = useRef(null);
  Outside(wrapperRef2);

  return (
    <div
      className={"landingContainer"}
      style={{
        height: window.innerHeight,
      }}
    >
      <div
        className={`${"landingMainContent"} ${
          contactUs
            ? "contactContainer"
            : !activeSection?.title
            ? "inActiveState"
            : "activeState"
        }`}
        style={
          !activeSection?.title
            ? {
                background:
                  "linear-gradient(119deg, #3a31ea -14%, #d01657 100%)",
              }
            : { background: `${activeSection?.bgColor}` }
        }
      >
        <div className={"fadeBackground"}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 381 416"
            className={"landingRightShape"}
          >
            <g fill="none" fill-rule="evenodd" opacity=".087">
              <g fill="#000">
                <path
                  d="M1412.882-441.424c-61.601 17.246-115.57 52.034-164.253 90.603-105.139 83.31-194.929 197.905-191.296 325.052 8.879 310.193 411.896 552.12 726.437 448.968 113.277-37.149 203.915-127.41 234.72-233.737 2.524-8.731 4.586-17.63 6.2-26.667 34.108-190.626-130.076-443.952-292.778-547.82-66.378-42.387-147.358-68.632-227.605-68.632-30.874 0-61.639 3.884-91.425 12.233z"
                  transform="translate(-1059)"
                />
              </g>
            </g>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 544 797"
            className="landingLeftShape"
          >
            <g fill="none" fill-rule="evenodd" opacity=".087">
              <g fill="#FFF">
                <path
                  d="M-285.37-332.432c-206.814 128.627-398.936 454.701-431.954 693.82-8.706 63.028-7.048 129.672 20.517 187.014 91.49 190.26 375.749 200.68 547.55 263.066 189.73 68.9 360.18 169.771 548.562 19.425 157.303-125.547 192.432-378.646 75.283-542.322C407.39 194.7 300.447 131.333 247.73 28.608c-51.14-99.665-44.616-224.742-110.287-315.479-27.585-38.128-64.92-64.904-107.247-81.447C-5.688-382.331-45.148-389-85.303-389c-69.63 0-141.338 20.043-200.068 56.568z"
                  transform="translate(0 -1) translate(-.086 .35)"
                />
              </g>
            </g>
          </svg>
          <div className="contentContainer">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                height: "100%",
                width: "100%",
                position: "relative",
              }}
            >
              <div className={"landingHeader"} style={{ position: "relative" }}>
                <SlidingMenu
                  langHandler={langHandler}
                  setActiveLang={setActiveLang}
                  languagesList={languagesList}
                  globalState={globalState}
                  myAnimation={myAnimation}
                  activeTab={activeTab}
                  open={openMenu}
                  onClose={() => setOpenMenu(false)}
                  langFlag={langFlag}
                />

                <span
                  onClick={() => {
                    setOpenMenu(true);
                    setLangFlag(false);
                  }}
                  className={"menuIcon"}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="13"
                    viewBox="0 0 19 13"
                  >
                    <g
                      stroke="#fff"
                      id="prefix__iconfinder_menu_2561466"
                      transform="translate(1 1)"
                    >
                      <path
                        id="prefix__Line_122"
                        d="M0 0L17 0"
                        class="prefix__cls-1"
                        data-name="Line 122"
                        transform="translate(0 5)"
                      />
                      <path
                        id="prefix__Line_123"
                        d="M0 0L17 0"
                        class="prefix__cls-1"
                        data-name="Line 123"
                      />
                      <path
                        id="prefix__Line_124"
                        d="M0 0L17 0"
                        class="prefix__cls-1"
                        data-name="Line 124"
                        transform="translate(0 11)"
                      />
                    </g>
                  </svg>
                </span>

                <span
                  className={"landingHeaderLinks"}
                  style={{
                    flex: 1,
                    display:
                      globalState?.themeDirection === "ltr" ? "flex" : "",
                  }}
                >
                  <span
                    // href="/"
                    onClick={() => {
                      myAnimation(0, activeTab, { title: undefined }, false);
                    }}
                    style={{
                      textDecoration: "none",
                      color: "#fff",
                      fontWeight: contactUs ? 300 : 800,
                      marginLeft:
                        globalState?.themeDirection === "ltr" ? "0px" : "30px",
                      marginRight:
                        globalState?.themeDirection === "ltr" ? "0px" : "",
                    }}
                  >
                    {activeLang.abbreviation === "FA"
                      ? " صفحه اول  "
                      : texts.home}
                  </span>
                  <span
                    onClick={() => {
                      myAnimation(0, activeTab, { title: undefined }, true);
                      // setContactUs(true);
                      // setActiveSection({ title: undefined });
                    }}
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      color: "#fff",
                      marginLeft:
                        globalState?.themeDirection === "ltr" ? "30px" : "",
                      fontWeight: contactUs ? 800 : 300,
                    }}
                  >
                    {activeLang.abbreviation !== "FA"
                      ? texts.contactUs
                      : " ارتباط با ما "}
                  </span>
                </span>
                <span className="headerLogoIcon">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="157"
                      height="47"
                      viewBox="0 0 157 47"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <g fill="#FFF">
                          <g>
                            <path
                              d="M130.394 45.793c.606-.561 1.568-.924 2.649-.924s2.042.363 2.649.924c-.607.56-1.568.923-2.65.923-1.08 0-2.042-.363-2.648-.923zm19.712-35.19c.061.003.117.039.148.093.032.059.03.13-.005.187l-.069.111-.186.308c.396.014.745.21.969.506-.232.307-.602.506-1.017.506-.179 0-.35-.037-.504-.103l-2.025 3.339c.398.013.75.208.975.506-.233.308-.602.507-1.017.507-.181 0-.353-.038-.509-.106l-2.027 3.341c.4.011.755.207.982.506-.233.308-.602.507-1.018.507-.183 0-.356-.038-.513-.108l-2.029 3.343c.403.01.76.206.988.507-.233.308-.602.507-1.017.507-.184 0-.36-.04-.518-.11l-2.03 3.345c.405.007.765.204.994.506-.233.308-.602.507-1.017.507-.187 0-.364-.04-.523-.112l-2.032 3.347c.408.005.77.203 1 .507-.232.308-.602.507-1.017.507-.188 0-.367-.041-.527-.115l-2.033 3.35c.41.003.775.201 1.006.506-.233.308-.602.507-1.017.507-.19 0-.37-.042-.533-.117l-2.033 3.352c.413.001.78.2 1.012.507-.233.307-.602.506-1.017.506-.192 0-.375-.042-.538-.119l-2.035 3.354h.001c.415 0 .784.2 1.018.507-.234.308-.603.507-1.018.507-.194 0-.378-.044-.542-.121l-.222.365c-.044.072-.123.116-.207.116h-27.857v-.013H89.251c-5.839-.002-10.588-4.757-10.588-10.602 0-2.095.63-4.037 1.68-5.683l.37-.53c1.926-2.647 5.024-4.39 8.538-4.39 4.672 0 8.471 3.805 8.471 8.482 0 4.678-3.799 8.482-8.47 8.482-3.504 0-6.354-2.854-6.354-6.361 0-3.508 2.85-6.361 6.353-6.361.286 0 .563.029.831.082.751.124 1.594.589 2.067 1.067.823.774 1.338 1.874 1.338 3.091 0 2.338-1.901 4.241-4.236 4.241-1.168 0-2.117-.95-2.117-2.12 0-1.17.95-2.12 2.117-2.12.35 0 .677-.175.875-.462l.066-.096c.365-.957-.297-1.82-1.528-1.522-2.057.286-3.648 2.06-3.648 4.2 0 2.338 1.9 4.24 4.235 4.24 3.504 0 6.353-2.853 6.353-6.36 0-3.508-2.85-6.362-6.353-6.362-4.67 0-8.47 3.804-8.47 8.482 0 4.677 3.8 8.481 8.47 8.481 4.11 0 7.641-2.381 9.395-5.817l.037.023 15.934-25.4c.309-.5.555-1.027.756-1.572.26-.693.921-1.152 1.66-1.152 2.145-.008 6.2-.008 6.2-.008h26.873zM122.068 38.5c.355.013.716.164.889.478.334.604.024 1.34-.256 1.874-.554.756-.428.62-.997 1.235-.674.544-1.576.765-2.484.448-.424-.152-.844-.373-1.298-.3-.534.084-1.265.846-1.8 1.515-.122.142-.15.343-.072.514.077.17.248.28.435.28 2.166.015 7.466.024 9.836.028.732.001 1.411-.38 1.793-1.004 1.658-2.71 3.31-5.424 4.965-8.136-.11.026-.22.05-.33.074-.976.206-2.049.418-2.942.022-.685-.303-.773-1.183-.085-2.055.517-.655 1.197-1.176 1.64-1.884.335-.534-.706-1.133-2.3-.587-.619.212-1.179.623-1.452 1.21-.391.843-.488 1.847-1.117 2.546-1.09 1.21-3.212 1.06-4.871.545l-.034-.01c-.262.289-.529.574-.79.864l-.125.14c-.655.76-1.334 1.563-1.48 2.55-.019.142.235.14.235.14.883-.078 1.673-.505 2.64-.487zm10.896 3.047c.294-.39.76-.641 1.286-.641.524 0 .99.251 1.285.64-.294.39-.761.642-1.285.642-.526 0-.992-.252-1.286-.641zm-15.637-15.451c.21.014.415.091.561.24.518.532.266 1.377.02 1.95-.408.955-1.096 1.812-1.955 2.404-.385.265-.832.469-1.305.471-.787.005-1.492-.587-2.206-.498-.862.108-1.404.927-1.809 1.59-.1.162-.194.33-.284.499-.093.175-.182.353-.266.533-.09.192-.067.418.06.587.128.169.339.253.548.218l.314-.05c.703-.099 1.464-.156 2.102.111.489.205.81.78.561 1.347-.091.209-.21.404-.344.587-.542.742-1.362 1.287-1.786 2.09-.106.202-.066.451.163.578.143.08.3.134.46.167.06.013.12.022.179.03.078.01.155.015.233.016 1.146.03 2.37-.555 2.807-1.589.403-.953.526-2.107 1.439-2.772 1.296-.943 3.11-.66 4.538-.207.937-1.047 1.974-2.074 2.365-3.427.127-.436-.161-.31-.464-.27-.783.107-1.52.479-2.309.47-.537-.005-1.054-.315-1.069-.99-.03-1.437 1.172-2.757 2.205-3.538.403-.305.88-.545 1.393-.548.792-.006 1.503.597 2.22.497.81-.113 1.337-.866 1.727-1.484.1-.157.193-.318.282-.481.262-.48.486-.98.687-1.489l.054-.136c-.364.086-.73.169-1.098.23-.203.035-.408.063-.614.08-.168.016-.337.024-.507.025-.132 0-.265-.004-.397-.014-.095-.008-.19-.018-.285-.032-.74-.105-1.519-.601-1.112-1.535.28-.641.836-1.119 1.349-1.636l.117-.12c.507-.533 1.14-1.182.31-1.485-.649-.237-1.424-.109-2.052.113-.889.314-1.423 1.127-1.767 2.26-.328 1.064-1.04 2.037-2.324 2.33-1.108.25-2.265.04-3.337-.305l-.014-.004c-.984 1.089-2.165 2.181-2.35 3.5-.008.053-.093.115.055.148.788.172 1.727-.456 2.804-.463l.1.002zm18.208 11.202c.294-.39.76-.64 1.286-.64.524 0 .991.25 1.286.64-.295.39-.762.641-1.286.641-.526 0-.992-.252-1.286-.64zm-3.266-14.943c-.983.016-1.961.204-2.925.43-.576 1.687-1.238 3.467-2.826 4.34-.468.257-1.026.311-1.561.164-.546-.15-1.06-.488-1.593-.402-.776.124-1.382.813-1.892 1.461-.39.496-.724 1.048-.801 1.661-.023.175-.104.37.157.382.968.045 1.957-.708 3.034-.487.313.064.58.297.665.613.153.574-.217 1.122-.492 1.607-.096.167-.195.33-.299.491-.119.184-.243.364-.371.541-.377.52-.788 1.014-1.208 1.498 1.39.378 3.072.497 3.869-.531.49-.634.537-1.514.916-2.259.83-1.633 3.4-2.56 4.864-1.471.362.269.579.726.407 1.248-.378 1.142-1.795 1.778-2.257 2.916-.23.566 1.29.388 2.337.221.442-.07.883-.16 1.32-.263l7.247-11.832-.14-.038c-.408-.108-.822-.19-1.24-.228-.131-.012-.263-.02-.394-.023-.105-.002-.21-.002-.314.002-.09.004-.18.01-.27.02-.606.063-1.233.285-1.619.78-.654.84-.68 2.075-1.377 2.915-1.16 1.398-3.951 1.74-4.744.435-.371-.61.15-1.422.611-1.932.235-.26.49-.5.736-.75.338-.344.7-.7.86-1.133.081-.218-.281-.37-.63-.376h-.07zm5.838 10.695c.293-.39.76-.641 1.285-.641.525 0 .991.251 1.286.64-.295.39-.761.642-1.286.642s-.992-.252-1.285-.641zM99.095 3.44c1.479-2.154 3.919-3.44 6.698-3.44.856 0 1.698.137 2.506.408l.292.097c2.585.864 4.521 2.957 5.18 5.601.518 2.07.17 4.297-.951 6.105l-12.473 19.883c-.09.143-.259.217-.425.184-.165-.032-.294-.163-.324-.33-.925-4.898-5.19-8.624-10.347-8.624-1.45 0-2.839.253-4.137.705-.066.024-.14.002-.183-.054-.043-.056-.045-.133-.005-.191l14.17-20.345zM140.678 28.8c.294-.389.76-.64 1.286-.64.524 0 .991.251 1.285.64-.294.39-.761.641-1.285.641-.526 0-.992-.251-1.286-.64zm5.532-16.11c.15 0 .289.08.362.212.074.132.07.293-.008.422l-5.281 8.614-.056-.018c-1.15-.362-2.406-.546-3.555-.166-1.337.443-1.77 1.592-2.124 2.73-.332 1.01-1.047 1.637-1.917 1.861-.585.151-1.245.224-1.802-.003-.153-.062-.397-.154-.388-.36.004-.119.1-.24.105-.25.462-.733 1.164-1.264 1.694-1.953.09-.118.17-.235.17-.235.348-.45.527-1.078.207-1.503-.591-.786-2.328-.491-3.691-.22l-.286.061.016-.043c.202-.523.43-1.037.697-1.531.09-.167.184-.33.284-.492.395-.633.924-1.409 1.75-1.528.516-.075 1.008.234 1.53.388.906.266 1.704-.085 2.321-.61.098-.084.113-.092.318-.295.601-.554 1.117-1.213 1.414-1.974.19-.508.464-1.347-.032-1.847-.175-.177-.434-.245-.687-.253-.601-.01-1.181.192-1.76.358-.411.115-1.193.168-1.148-.057.098-.479.35-.91.628-1.309h11.239zm-2.961 11.862c.294-.39.761-.641 1.286-.641.524 0 .991.252 1.286.64-.295.39-.762.642-1.286.642-.525 0-.992-.252-1.286-.641zm-9.156-11.863l-.024.041c-.261.46-.55.913-.537 1.405.015.612.61.878 1.1.87.995-.018 1.867-.625 2.697-.512.201.032.082.43.082.43-.087.565-.388 1.077-.738 1.536-.654.855-1.558 1.748-2.489 1.495-.885-.24-1.83-.626-2.601-.207-1.6.869-2.26 2.659-2.837 4.346l-.162.037c-.976.22-1.966.44-2.935.39-.4-.02-.592-.28-.454-.527.501-.907 1.435-1.446 1.955-2.299.41-.672.312-1.416-.204-1.77-1.139-.783-2.836-.398-3.947.446-.027.02-.053.041-.079.063-.843.614-.99 1.674-1.364 2.607-.702 1.75-2.616 1.618-4.217 1.184 0 0 .883-1.048 1.253-1.566.119-.168.234-.34.344-.513.374-.592.883-1.218.743-1.945-.085-.446-.496-.676-.915-.702l-.093-.003c-.568 0-1.114.186-1.66.34-.557.153-1.263.354-1.224-.02.092-.756.457-1.4.926-1.969.55-.669 1.177-1.327 1.931-1.353.644-.023 1.3.482 2.025.505 1.24.04 2.08-1.056 2.714-2.116.07-.12.198-.193.336-.193h10.374zm11.728 7.614c.293-.389.76-.64 1.285-.64.525 0 .991.251 1.286.64-.295.39-.761.641-1.286.641s-.992-.251-1.285-.64zm2.57-4.248c.295-.39.761-.641 1.287-.641.524 0 .991.252 1.285.641-.294.39-.76.641-1.285.641-.526 0-.992-.252-1.286-.641zm2.572-4.25c.607-.56 1.567-.924 2.649-.924 1.08 0 2.042.363 2.648.924-.606.56-1.567.923-2.648.923-1.082 0-2.042-.362-2.65-.923zM55.116 44.003c0-1.498 1.214-2.713 2.71-2.713 1.495 0 2.71 1.215 2.71 2.713 0 1.497-1.215 2.713-2.71 2.713-1.496 0-2.71-1.216-2.71-2.713 0 1.497-1.214 2.713-2.71 2.713-1.495 0-2.709-1.216-2.709-2.713 0 1.497-1.214 2.713-2.71 2.713-1.495 0-2.709-1.216-2.709-2.713 0-1.498 1.214-2.713 2.71-2.713 1.495 0 2.71 1.215 2.71 2.713 0-1.498 1.213-2.713 2.709-2.713 1.495 0 2.71 1.215 2.71 2.713zM5.44 46.7C2.4 46.481 0 43.94 0 40.84h4.995c0 2.463 1.996 4.462 4.455 4.462h8.138c2.459 0 4.455-2 4.455-4.461h4.995c0 3.098-2.401 5.64-5.44 5.86v.015H5.44V46.7zm28.08-2.697c0-1.498 1.213-2.713 2.709-2.713 1.495 0 2.71 1.215 2.71 2.713 0 1.497-1.215 2.713-2.71 2.713-1.496 0-2.71-1.216-2.71-2.713 0 1.497-1.214 2.713-2.71 2.713-1.495 0-2.709-1.216-2.709-2.713 0-1.498 1.214-2.713 2.71-2.713 1.495 0 2.71 1.215 2.71 2.713zM0 40.84h4.985v-7.228H0v7.228zm27.038 0h-4.985V30.73c0-1.653 1.339-2.994 2.99-2.994h1.995V38.05h2.853c2.459 0 4.455-1.999 4.455-4.461h4.995c0 1.797-.808 3.408-2.08 4.486h18.934c2.458 0 4.455-2 4.455-4.461 0-2.463-1.996-4.461-4.455-4.462h-3.263c-1.893 0-3.512 1.185-4.157 2.853-.371.969-1.3 1.608-2.337 1.608h-2.956c0-3.242 2.629-5.875 5.867-5.875h10.428c3.239 0 5.868 2.633 5.868 5.876 0 3.242-2.63 5.875-5.868 5.875H28.29v-.025h-1.251v1.378zm-13.509-6.78c1.496 0 2.71 1.216 2.71 2.714 0 1.497-1.214 2.713-2.71 2.713-1.495 0-2.71-1.216-2.71-2.713 0-1.498 1.215-2.713 2.71-2.713zm-8.534-.448H0c0-3.243 2.629-5.876 5.868-5.876h4.93c.886 0 1.47.75 1.507 1.406l-2.855.008c-2.459 0-4.455 2-4.455 4.462zm34.346-.025h-4.985v-2.856c0-1.654 1.339-2.995 2.99-2.995h1.995v5.85zM28.126 18.467H7.29c-1.808 0-3.617 1.098-3.617 2.908 0 1.81 1.468 3.28 3.275 3.28h58.697c-.111.522-.608 1.005-.946 1.04H4.314c-2.38 0-4.314-1.936-4.314-4.32 0-2.384 1.933-4.32 4.314-4.32h5.267v-.003h14.962c2.459 0 4.455-1.998 4.455-4.46h4.995c0 3.242-2.629 5.875-5.867 5.875zm29.956-3.111h-6.2c-2.38 0-4.313-1.936-4.313-4.32 0-2.292 1.786-4.17 4.04-4.311v-.009h8.168c3.239 0 5.868 2.633 5.868 5.875 0 3.243-2.63 5.876-5.868 5.876H42.043c-3.238 0-5.867-2.633-5.867-5.876h4.995c0 2.463 1.996 4.461 4.455 4.461h10.569c2.458 0 4.455-1.998 4.455-4.46 0-2.463-1.996-4.462-4.455-4.462h-1.866c-1.615.196-3.088 1.273-3.088 2.906 0 1.81 1.468 3.28 3.276 3.28h4.51c-.11.522-.607 1.005-.945 1.04zm-16.921-2.765h-4.985V2.995C36.176 1.34 37.515 0 39.166 0h1.995v12.591zm-7.168 0h-4.985V2.995C29.008 1.34 30.347 0 31.998 0h1.995v12.591zm21.818-9.878C55.81 1.216 57.025 0 58.52 0c1.495 0 2.709 1.216 2.709 2.713 0 1.498-1.214 2.713-2.71 2.713-1.495 0-2.71-1.215-2.71-2.713 0 1.498-1.213 2.713-2.709 2.713-1.495 0-2.71-1.215-2.71-2.713 0-1.497 1.215-2.713 2.71-2.713 1.496 0 2.71 1.216 2.71 2.713z"
                              transform="translate(-642 -39) translate(642 39)"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                </span>
                <div
                  className={"landingHeaderLinks"}
                  style={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <span
                    onClick={() =>
                      (window.location =
                        "https://www.instagram.com/ghalichin.ir/")
                    }
                    className="headerInstagram"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="21"
                      viewBox="0 0 22 21"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <g fill="#FFF">
                          <g>
                            <path
                              d="M14.543 0H6.17C2.768 0 0 2.768 0 6.17v8.372c0 3.403 2.768 6.171 6.17 6.171h8.372c3.403 0 6.171-2.768 6.171-6.17V6.17c0-3.403-2.768-6.171-6.17-6.171zm4.086 14.543c0 2.256-1.83 4.086-4.087 4.086H6.171c-2.258 0-4.087-1.83-4.087-4.087V6.171c0-2.258 1.83-4.087 4.087-4.087h8.372c2.257 0 4.086 1.83 4.086 4.087v8.372z"
                              transform="translate(-307 -60) translate(307.161 60)"
                            />
                            <path
                              d="M10.357 5c-2.954 0-5.358 2.403-5.358 5.356 0 2.954 2.404 5.358 5.358 5.358 2.954 0 5.357-2.404 5.357-5.358C15.714 7.402 13.31 5 10.357 5zm0 8.63c-1.808 0-3.274-1.466-3.274-3.274 0-1.807 1.466-3.273 3.274-3.273 1.807 0 3.273 1.466 3.273 3.274 0 1.807-1.466 3.273-3.274 3.273zM15.724 3.756c.709 0 1.284.575 1.284 1.284 0 .708-.575 1.283-1.284 1.283-.709 0-1.284-.575-1.284-1.283 0-.709.575-1.284 1.284-1.284z"
                              transform="translate(-307 -60) translate(307.161 60)"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>

                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() =>
                      (window.location = "https://twitter.com/ghalichin?s=08")
                    }
                    className="headerInstagram"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="19"
                      viewBox="0 0 22 19"
                      style={{
                        margin: "0px 20px",
                        //  marginRight: "20px"
                      }}
                    >
                      <g fill="none" fill-rule="evenodd">
                        <g fill="#FFF">
                          <path
                            d="M280.742 63.63c-.468.207-.954.371-1.453.49.55-.523.963-1.176 1.196-1.905.067-.208-.16-.388-.348-.277-.694.412-1.441.72-2.221.918-.046.011-.092.017-.14.017-.141 0-.28-.052-.388-.148-.83-.732-1.898-1.135-3.007-1.135-.48 0-.964.075-1.44.222-1.473.457-2.61 1.673-2.966 3.172-.134.563-.17 1.126-.108 1.673.007.063-.023.107-.041.128-.032.036-.078.057-.126.057l-.016-.001c-3.225-.3-6.133-1.853-8.19-4.375-.104-.129-.305-.113-.389.03-.402.69-.615 1.48-.615 2.285 0 1.231.495 2.392 1.355 3.239-.362-.086-.712-.22-1.037-.401-.157-.088-.35.025-.353.204-.022 1.83 1.05 3.459 2.654 4.192l-.097.001c-.254 0-.512-.024-.765-.073-.177-.034-.326.134-.271.306.52 1.627 1.921 2.826 3.597 3.098-1.39.933-3.01 1.426-4.696 1.426h-.526c-.162 0-.299.105-.34.262-.04.154.034.317.172.398 1.9 1.105 4.067 1.69 6.267 1.69 1.927 0 3.729-.383 5.356-1.137 1.492-.69 2.81-1.679 3.919-2.936 1.032-1.171 1.84-2.523 2.4-4.019.533-1.425.815-2.946.815-4.398v-.07c0-.232.105-.452.29-.601.697-.567 1.305-1.234 1.806-1.983.132-.198-.076-.446-.294-.35z"
                            transform="translate(-260 -61)"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>

                  <span
                    style={{
                      borderRadius: "50%",
                      height: "25px",
                      width: "25px",
                      backgroundColor: "#fff",
                      // marginRight: "20px",
                      display: contactUs ? "none" : "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => setOpenSwitchLang(true)}
                    // className="headerInstagram"
                    className="headerSwitchLang"
                  >
                    <span
                      style={{
                        color: "#5e6777",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {activeLang?.abbreviation}
                    </span>
                  </span>
                  {openSwitchLang && (
                    <div
                      ref={wrapperRef2}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        transition: "height 0.5s",
                        height: openSwitchLang ? `${4 * 45}px` : "0px",
                        borderRadius: "4px",
                        position: "absolute",
                        top: "45px",
                        left: "0px",
                        zIndex: 1000,
                        backgroundColor: "#fff",
                        boxShadow: openSwitchLang
                          ? "0 0 35px 0 rgba(34, 53, 132, 0.1)"
                          : "",
                        border: openSwitchLang
                          ? "1px solid rgba(34, 53, 132, 0.1)"
                          : "",
                        maxHeight: "300px",
                        overflow: 4 > 6 ? "scroll" : "",
                        padding: "0px 20px",
                      }}
                    >
                      {/* {openSwitchLang == true && (
                        <div
                          className={"switchLangModal"}
                          style={{
                            width: "100%",
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "flex-start",
                            // minHeight: "50px",
                            // maxHeight: "50px",
                            cursor: "pointer",
                            padding: "0px 15px",
                          }}
                        > */}
                      {languagesList?.map((lang, index) => (
                        <span
                          onClick={() => {
                            setTimeout(() => {
                              setOpenSwitchLang(false);
                            }, 100);
                            // setActiveSection({ title: undefined });
                            // setBeforeTab(0);
                            // setActiveTab(0);
                            setActiveLang(lang);
                            langHandler(lang.key);
                          }}
                          className="langRowContainer  switchLangModal"
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            width: "100%",
                            padding: "0px 10px",
                            borderBottom:
                              index !== 3 ? "1px solid #d3d3d3" : "",
                            height: "45px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            {lang?.title}
                          </span>
                          <span
                            style={{
                              fontSize: "14px",
                              paddingRight:
                                globalState.themeDirection === "ltr"
                                  ? "0px"
                                  : "25px",
                              paddingLeft:
                                globalState.themeDirection === "ltr"
                                  ? "25px"
                                  : "0px",
                              fontWeight: 700,
                            }}
                          >
                            {lang?.abbreviation}
                          </span>
                        </span>
                      ))}
                      {/* </div>
                      )} */}
                    </div>
                  )}
                </div>

                <span
                  onClick={() => {
                    setOpenMenu(true);
                    setLangFlag(true);
                  }}
                  className={"langIcon"}
                >
                  <span
                    style={{
                      height: "28px",
                      width: "28px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      color: "#5e6777",
                      fontSize: "14px",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {activeLang?.abbreviation}
                  </span>
                </span>
              </div>
              <div className="SwipeableContainer">
                {contactUs ? (
                  <div className="swipeableContact">
                    <div className={"mapContainer"}>
                      <div
                        className={
                          globalState.themeDirection === "ltr"
                            ? "contactInfoLtr"
                            : "contactInfo"
                        }
                      >
                        <div
                          className="contactInfoRows"
                          style={{
                            marginBottom: "20px",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="13"
                            viewBox="0 0 15 13"
                          >
                            <g fill="none" fill-rule="evenodd">
                              <g fill="#C3C6E1" fill-rule="nonzero">
                                <path
                                  d="M1181.139 335c.2 0 .361.162.361.361v12.278c0 .2-.162.361-.361.361h-.722c-.2 0-.361-.162-.361-.361V341.5h-2.41c-.12 0-.267-.027-.41-.07-.142-.044-.279-.105-.376-.17l-1.715-1.324c-.097-.067-.145-.154-.145-.242s.048-.176.145-.242l1.715-1.321c.097-.067.234-.127.377-.17.142-.045.29-.072.41-.072h2.409v-2.528c0-.2.161-.361.36-.361zm5.66 1.444c.118 0 .266.027.409.071.142.044.278.104.376.171l1.715 1.322c.097.067.145.154.145.242s-.048.175-.145.241l-1.716 1.323c-.097.066-.234.127-.376.17-.142.045-.29.072-.409.072h-4.358l-.579-3.612z"
                                  transform="translate(-1175 -335)"
                                />
                              </g>
                            </g>
                          </svg>
                          <div className="contactInfoTop">
                            <span className="infoTopTitle">
                              {texts.address}
                              {"    : "}
                            </span>
                            <span
                              className="infoRowContent"
                              style={{
                                color: "#727d93",
                              }}
                            >
                              {
                                "میدان ولیعصر - خیابان ولیعصر - کوچه نور بخش - ساختمان نوربخش - پلاک ۴ - رویای کمال"
                              }
                            </span>
                          </div>
                        </div>
                        <div className="contactInfoRows">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="13"
                            viewBox="0 0 13 13"
                          >
                            <g fill="none" fill-rule="evenodd">
                              <g fill="#C3C6E1" fill-rule="nonzero">
                                <path
                                  d="M1178.385 457c.523 0 .948.425.948.948 0 .654.167 1.491.496 2.488.109.345.018.714-.235.967l-1.285 1.333c.899 1.7 1.991 2.788 3.71 3.697l1.49-1.06c.201-.208.608-.311.936-.198.685.226 1.782.492 2.607.492.523 0 .948.425.948.948v2.437c0 .523-.425.948-.948.948-6.533 0-12.052-5.519-12.052-12.052 0-.523.425-.948.948-.948zm4.675 0c3.412 0 4.94 2.48 4.94 4.94 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-2.2-1.367-4.42-4.42-4.42-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26zm0 2.6c1.487 0 2.34.853 2.34 2.34 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-.83-.316-1.82-1.82-1.82-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26z"
                                  transform="translate(-1175 -457)"
                                />
                              </g>
                            </g>
                          </svg>
                          <div
                            className="contactInfoTop"
                            style={{
                              position: "relative",
                            }}
                          >
                            <span className="infoTopTitle">
                              {" "}
                              {texts.phoneNumber}
                              {" :"}
                            </span>
                            <span
                              className="infoRowContent"
                              style={{
                                color: "#727d93",
                              }}
                            >
                              {"021-88809006"}
                            </span>

                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://trustseal.enamad.ir/?id=156356&amp;code=5UDVGaiUaXbzCtNYFHDL"
                              style={{
                                height: "60px",
                                width: "50px",
                                position: "absolute",
                                left:
                                  globalState.themeDirection === "ltr" ? "" : 0,
                                right:
                                  globalState.themeDirection === "ltr" ? 0 : "",
                                bottom: 0,
                                cursor: "pointer",
                                border: "1px solid rgba(200,200,200,0.3)",
                                borderRadius: "8px",
                              }}
                            >
                              <img
                                alt="enamed"
                                src="./static/img/namad-2.png"
                                style={{ height: "100%", width: "100%" }}
                              ></img>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          globalState?.themeDirection === "ltr"
                            ? "contactFollowUsLtr"
                            : " contactFollowUs"
                        }
                      >
                        <span className="followText">
                          {"ما را روی نقشه دنبال کنید"}
                        </span>
                        <span
                          style={{
                            display: "flex",
                            margin: "0px",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <img
                            alt={"Location"}
                            style={{
                              height: "22px",
                              width: "18px",
                              marginLeft:
                                globalState.themeDirection === "ltr" ? "" : 15,
                              marginRight:
                                globalState.themeDirection === "ltr" ? 15 : "",
                            }}
                            src="./static/img/location-icon.png"
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 32 30"
                          >
                            <g fill="none" fill-rule="evenodd">
                              <g fill="#727D93" fill-rule="nonzero">
                                <path
                                  d="M807 566c7.718 0 14 5.832 14 13 0 4.628-2.626 8.688-6.56 10.992.346.594.56 1.274.56 2.008 0 2.206-1.794 4-4 4s-4-1.794-4-4c-1.426 0-2.756-.034-4.01-.098l.01.098c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-.414.082-.804.198-1.18-4.144-1.122-6.198-3.048-6.198-5.82 0-.552.448-1 1-1 .992 0 1.716-.284 2.214-.864 1.168-1.366.802-3.956.798-3.982C793 571.832 799.28 566 807 566zm0 2c-6.618 0-12 4.934-12 11 .012 0 .51 3.362-1.266 5.436-.662.772-1.526 1.26-2.582 1.46.5 1.412 2.266 2.464 5.172 3.152.71-.644 1.644-1.048 2.676-1.048 1.412 0 2.65.74 3.362 1.85 1.43.088 2.946.15 4.638.15.192 0 .38-.018.572-.026.696-1.176 1.966-1.974 3.428-1.974.716 0 1.378.204 1.958.534 3.604-1.9 6.042-5.458 6.042-9.534 0-6.066-5.382-11-12-11zm4.021 12.78c.124-.538.654-.876 1.196-.756.54.122.88.656.758 1.196-.632 2.814-3.09 4.78-5.975 4.78-2.884 0-5.342-1.964-5.976-4.78-.12-.54.218-1.074.756-1.196.54-.116 1.074.216 1.196.756.426 1.896 2.082 3.22 4.024 3.22 1.944 0 3.597-1.324 4.021-3.22zm-8.016-5.78c.55 0 .995.672.995 1.5s-.446 1.5-.995 1.5c-.55 0-1.005-.672-1.005-1.5s.436-1.5.985-1.5zm8 0c.55 0 .995.672.995 1.5s-.446 1.5-.995 1.5c-.55 0-1.005-.672-1.005-1.5s.436-1.5.985-1.5z"
                                  transform="translate(-789 -566)"
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                      </div>
                      <MyMap />
                    </div>
                    <div className="responsiveContactInfo">
                      <div
                        className="contactInfoRows"
                        style={{
                          marginBottom: "20px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="13"
                          viewBox="0 0 15 13"
                        >
                          <g fill="none" fill-rule="evenodd">
                            <g fill="#C3C6E1" fill-rule="nonzero">
                              <path
                                d="M1181.139 335c.2 0 .361.162.361.361v12.278c0 .2-.162.361-.361.361h-.722c-.2 0-.361-.162-.361-.361V341.5h-2.41c-.12 0-.267-.027-.41-.07-.142-.044-.279-.105-.376-.17l-1.715-1.324c-.097-.067-.145-.154-.145-.242s.048-.176.145-.242l1.715-1.321c.097-.067.234-.127.377-.17.142-.045.29-.072.41-.072h2.409v-2.528c0-.2.161-.361.36-.361zm5.66 1.444c.118 0 .266.027.409.071.142.044.278.104.376.171l1.715 1.322c.097.067.145.154.145.242s-.048.175-.145.241l-1.716 1.323c-.097.066-.234.127-.376.17-.142.045-.29.072-.409.072h-4.358l-.579-3.612z"
                                transform="translate(-1175 -335)"
                              />
                            </g>
                          </g>
                        </svg>
                        <div className="contactInfoTop">
                          <span className="infoTopTitle">
                            {texts.address}
                            {"    : "}
                          </span>
                          <span className="infoRowContent">
                            {
                              "میدان ولیعصر - خیابان ولیعصر - کوچه نور بخش - ساختمان نوربخش - پلاک ۴ - رویای کمال"
                            }
                          </span>
                        </div>
                      </div>
                      <div
                        className="contactInfoRows"
                        style={{
                          marginBottom: "20px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                        >
                          <g fill="none" fill-rule="evenodd">
                            <g fill="#C3C6E1" fill-rule="nonzero">
                              <path
                                d="M1178.385 457c.523 0 .948.425.948.948 0 .654.167 1.491.496 2.488.109.345.018.714-.235.967l-1.285 1.333c.899 1.7 1.991 2.788 3.71 3.697l1.49-1.06c.201-.208.608-.311.936-.198.685.226 1.782.492 2.607.492.523 0 .948.425.948.948v2.437c0 .523-.425.948-.948.948-6.533 0-12.052-5.519-12.052-12.052 0-.523.425-.948.948-.948zm4.675 0c3.412 0 4.94 2.48 4.94 4.94 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-2.2-1.367-4.42-4.42-4.42-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26zm0 2.6c1.487 0 2.34.853 2.34 2.34 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-.83-.316-1.82-1.82-1.82-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26z"
                                transform="translate(-1175 -457)"
                              />
                            </g>
                          </g>
                        </svg>
                        <div
                          className="contactInfoTop"
                          style={{ position: "relative" }}
                        >
                          <span className="infoTopTitle">
                            {texts.phoneNumber}
                            {" :"}
                          </span>
                          <span className="infoRowContent">
                            {"021-88809006"}
                          </span>

                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://trustseal.enamad.ir/?id=156356&amp;code=5UDVGaiUaXbzCtNYFHDL"
                            style={{
                              height: "60px",
                              width: "50px",
                              position: "absolute",
                              // left: 0,
                              bottom: 0,
                              left:
                                globalState.themeDirection === "ltr" ? "" : 0,
                              right:
                                globalState.themeDirection === "ltr" ? 0 : "",
                              cursor: "pointer",
                              // border: "1px solid rgba(200,200,200,0.3)",
                              borderRadius: "8px",
                            }}
                          >
                            <img
                              alt="enamad"
                              src="./static/img/namad-2.png"
                              style={{ height: "100%", width: "100%" }}
                            ></img>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      className="slidesContainer"
                      style={{
                        height: "100%",
                        width: "100%",
                        flexDirection: "column",
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flex:
                            window.innerHeight < 800
                              ? 1.5
                              : window.innerHeight < 900
                              ? 2
                              : window.innerHeight < 1000
                              ? 2.5
                              : 3,
                        }}
                      ></div>
                      <div
                        className="slidesContainer"
                        style={{
                          width: "100%",
                          display: "flex",
                          flex:
                            window.innerHeight < 800
                              ? 13
                              : window.innerHeight < 900
                              ? 12
                              : window.innerHeight < 1000
                              ? 11
                              : 10,
                          flexDirection: "row",
                        }}
                      >
                        {sectionsData?.map((item, index) => (
                          <div
                            id={`tabText${index}`}
                            className="slidesTextContainer"
                            style={{
                              // border: "3px solid green",
                              position: "relative",
                              height: "100%",
                              alignSelf: "flex-end",
                              display: index === 0 ? "flex" : "none",
                              opacity: index === 0 ? 1 : 0.2,
                              paddingRight:
                                index === 0
                                  ? globalState?.themeDirection === "ltr"
                                    ? ""
                                    : "120px"
                                  : "",
                              paddingLeft:
                                index === 0
                                  ? globalState?.themeDirection === "ltr"
                                    ? "120px"
                                    : "0px"
                                  : "",
                              marginRight:
                                index === 0
                                  ? globalState?.themeDirection === "ltr"
                                    ? ""
                                    : "100px"
                                  : "",
                              marginLeft:
                                index === 0
                                  ? globalState?.themeDirection === "ltr"
                                    ? "100px"
                                    : ""
                                  : "",
                              flex: index === 0 ? 1.5 : "",
                            }}
                          >
                            <strong
                              className="slidesTextTitle"
                              // style={{ border: "1px solid red" }}
                            >
                              {sectionsData[index]?.title}
                            </strong>
                            <p className="slidesTextContent" style={{}}>
                              {index === 0 ? (
                                <span className="slidesLightContent">
                                  {sectionsData[index]?.boldText}
                                </span>
                              ) : (
                                <strong className="slidesStrongContent">
                                  {sectionsData[index]?.boldText}
                                </strong>
                              )}
                              <span className="slidesLightContent">
                                {sectionsData[index]?.lightText}
                              </span>
                            </p>
                            {sectionsData[index]?.title && (
                              <Button
                                style={
                                  {
                                    // position: "absolute",
                                    // bottom:
                                    //   window.innerHeight < 1000 ? "13%" : "15%",
                                    // width: "80%",
                                  }
                                }
                                variant="contained"
                                onClick={
                                  () => btnHandler(index)
                                  // (window.location =
                                  //   "https://shop.ghalichin.com/")
                                }
                                className="slideTextBtn"
                              >
                                {activeLang?.abbreviation == "FA"
                                  ? `ورود به بخش   ${sectionsData[index].title}`
                                  : sectionsData[index].title}
                              </Button>
                            )}
                          </div>
                        ))}
                        <div
                          className="slidesImgContainer"
                          style={{
                            display: "flex",
                            height: "100%",
                          }}
                        >
                          <div
                            className="animationContainer"
                            style={{
                              justifyContent: "center",
                              alignItems: "flex-end",
                            }}
                          >
                            <MyCarousel
                              globalState={globalState}
                              sectionsData={sectionsData}
                              activeTab={activeTab}
                              beforeTab={beforeTab}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flex:
                            window.innerHeight < 800
                              ? 1
                              : window.innerHeight < 900
                              ? 1.2
                              : window.innerHeight < 1000
                              ? 1.5
                              : 2,
                        }}
                      ></div>
                    </div>
                    <SwipeableViews
                      containerStyle={{
                        height: "100%",
                        width: "100%",
                      }}
                      onChangeIndex={(i) => {
                        setActiveSection(
                          i === 0 ? sectionsData[0] : sectionsData[i]
                        );

                        setActiveTab(i);
                      }}
                      disableLazyLoading={true}
                      animateHeight={true}
                      hysteresis={0.6}
                      animateTransitions={true}
                      draggable={false}
                      className="swipeableSlides"
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      axis={"x-reverse"}
                      index={activeTab}
                    >
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <div className={"mainSlideContainer"}>
                          <span className="mainSlideText">
                            {texts["landingText"]}
                          </span>
                          <span
                            className={"mainslideImgContainer"}
                            style={{
                              backgroundImage:
                                "url(" + `${sectionsData[0].img}` + ")",
                              backgroundSize: "contain",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center center",
                            }}
                          ></span>
                        </div>
                      </div>
                      {sectionsData.slice(1, 6)?.map((section, index) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <div className="slidesContainer2">
                              <div
                                className="slidesTextContainer"
                                style={{
                                  position: "relative",
                                }}
                              >
                                <strong className="slidesTextTitle">
                                  {section.title}
                                </strong>
                                <span className="slidesTextContentRes">
                                  {section?.boldText + " " + section.lightText}
                                </span>
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.11)",
                                    position: "absolute",
                                    bottom: 15,
                                  }}
                                  onClick={() => btnHandler(index + 1)}
                                  className="slideTextBtn"
                                >
                                  {activeLang?.abbreviation === "FA"
                                    ? `ورود به بخش   ${section?.title}`
                                    : section?.title}
                                </Button>
                              </div>
                              <div
                                className="slidesImgContainer"
                                style={{
                                  backgroundImage:
                                    "url(" +
                                    `${section.gif}` +
                                    "),url('./static/svg/rectangle.svg')",
                                  backgroundSize: "contain",
                                  backgroundPosition: "center center",
                                  backgroundRepeat: "no-repeat no-repeat",
                                }}
                              ></div>
                            </div>
                          </div>
                        );
                      })}
                    </SwipeableViews>
                  </>
                )}
              </div>
              <div className="sliderBottomContainer">
                <div
                  onClick={() => {
                    myAnimation(0, activeTab, { title: undefined }, false);
                  }}
                  className="sliderBottomLogo"
                >
                  {activeTab === 0 && !contactUs ? (
                    <svg
                      style={{ maxHeight: "55px" }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="88"
                      height="63"
                      viewBox="0 0 88 63"
                    >
                      <defs>
                        <linearGradient
                          id="8029flgbaa"
                          x1="-7.366%"
                          x2="114.618%"
                          y1="24.374%"
                          y2="75.626%"
                        >
                          <stop offset="0%" stop-color="#3F57E6" />
                          <stop offset="100%" stop-color="#CE1F59" />
                        </linearGradient>
                      </defs>
                      <g fill="none" fill-rule="evenodd">
                        <g
                          fill="url(#8029flgbaa)"
                          transform="translate(-1136 -767)"
                        >
                          <path d="M1150.477 804c1.186 0 1.97 1.026 2.018 1.926l-3.827.011c-3.296 0-5.972 2.739-5.972 6.112h-.013v9.902h.013c0 3.373 2.676 6.112 5.972 6.112h10.91c3.296 0 5.972-2.739 5.972-6.112h.013v-13.849c0-2.265 1.795-4.102 4.009-4.102h2.674v14.127h3.824c3.297 0 5.973-2.739 5.973-6.112h.013v-3.913c0-2.265 1.795-4.102 4.009-4.102h2.674v8.015c0 2.463-1.083 4.669-2.789 6.145h25.382c3.296 0 5.972-2.738 5.972-6.111 0-3.373-2.676-6.112-5.972-6.112h-4.374c-2.538 0-4.707 1.623-5.572 3.909-.498 1.326-1.744 2.202-3.133 2.202h-3.964c0-4.441 3.525-8.048 7.866-8.048h13.98c4.34 0 7.865 3.607 7.865 8.049 0 4.442-3.524 8.049-7.866 8.049h-42.211v-.034h-1.677v1.887c0 4.245-3.219 7.727-7.293 8.028V830h-21.66v-.021c-4.074-.3-7.293-3.783-7.293-8.028v-9.902c0-4.442 3.524-8.049 7.866-8.049h6.61zm34.09 18.566c2.004 0 3.632 1.666 3.632 3.717 0 2.052-1.628 3.717-3.632 3.717-2.005 0-3.633-1.665-3.633-3.717 0 2.052-1.627 3.717-3.632 3.717s-3.632-1.665-3.632-3.717c0-2.051 1.627-3.717 3.632-3.717 1.94 0 3.527 1.56 3.627 3.52l.005.185.005-.185c.1-1.96 1.688-3.52 3.628-3.52zm28.951 0c2.005 0 3.633 1.666 3.633 3.717 0 2.052-1.628 3.717-3.633 3.717-2.004 0-3.632-1.665-3.632-3.717 0 2.052-1.627 3.717-3.632 3.717s-3.632-1.665-3.632-3.717c0 2.052-1.628 3.717-3.633 3.717s-3.632-1.665-3.632-3.717c0-2.051 1.627-3.717 3.632-3.717 1.94 0 3.527 1.56 3.627 3.52l.005.185.006-.185c.1-1.96 1.687-3.52 3.627-3.52 1.94 0 3.527 1.56 3.627 3.52l.005.185.005-.185c.1-1.96 1.687-3.52 3.627-3.52zm-59.381-9.902c2.005 0 3.632 1.665 3.632 3.717 0 2.051-1.627 3.717-3.632 3.717s-3.632-1.666-3.632-3.717c0-2.052 1.627-3.717 3.632-3.717zM1181.57 767v17.151c0 4.417-3.525 8.003-7.866 8.003h-27.931c-2.424 0-4.85 1.496-4.85 3.962s1.968 4.468 4.392 4.468H1224c-.149.71-.814 1.368-1.267 1.416h-80.95c-3.192 0-5.783-2.637-5.783-5.884 0-3.248 2.591-5.885 5.783-5.885h7.061v-.003h20.057c3.296 0 5.973-2.723 5.973-6.077h.013V771.08c0-2.253 1.795-4.079 4.009-4.079h2.674zm9.608 0v17.151h.013c0 3.354 2.676 6.077 5.973 6.077h14.168c3.296 0 5.972-2.723 5.972-6.077 0-3.353-2.676-6.076-5.972-6.076h-2.5c-2.166.266-4.14 1.733-4.14 3.958 0 2.466 1.967 4.468 4.391 4.468h6.046c-.148.71-.814 1.368-1.267 1.416h-8.31c-3.192 0-5.784-2.637-5.784-5.884 0-3.122 2.395-5.68 5.416-5.873v-.012h10.95c4.342 0 7.866 3.586 7.866 8.003s-3.524 8.003-7.866 8.003h-23.773c-4.341 0-7.866-3.586-7.866-8.003V771.08c0-2.253 1.795-4.079 4.01-4.079h2.673zm16.007 0c2.004 0 3.632 1.656 3.632 3.696s-1.628 3.695-3.632 3.695c-2.005 0-3.633-1.656-3.633-3.695 0-2.04 1.628-3.696 3.633-3.696zm7.264 0c2.005 0 3.633 1.656 3.633 3.696s-1.628 3.695-3.633 3.695c-2.004 0-3.632-1.656-3.632-3.695 0-2.04 1.628-3.696 3.632-3.696z" />
                        </g>
                      </g>
                    </svg>
                  ) : (
                    <svg
                      style={{ maxHeight: "55px" }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="88"
                      height="63"
                      viewBox="0 0 88 63"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <g fill="#727D93">
                          <path
                            d="M1150.477 804c1.186 0 1.97 1.026 2.018 1.926l-3.827.011c-3.296 0-5.972 2.739-5.972 6.112h-.013v9.902h.013c0 3.373 2.676 6.112 5.972 6.112h10.91c3.296 0 5.972-2.739 5.972-6.112h.013v-13.849c0-2.265 1.795-4.102 4.009-4.102h2.674v14.127h3.824c3.297 0 5.973-2.739 5.973-6.112h.013v-3.913c0-2.265 1.795-4.102 4.009-4.102h2.674v8.015c0 2.463-1.083 4.669-2.789 6.145h25.382c3.296 0 5.972-2.738 5.972-6.111 0-3.373-2.676-6.112-5.972-6.112h-4.374c-2.538 0-4.707 1.623-5.572 3.909-.498 1.326-1.744 2.202-3.133 2.202h-3.964c0-4.441 3.525-8.048 7.866-8.048h13.98c4.34 0 7.865 3.607 7.865 8.049 0 4.442-3.524 8.049-7.866 8.049h-42.211v-.034h-1.677v1.887c0 4.245-3.219 7.727-7.293 8.028V830h-21.66v-.021c-4.074-.3-7.293-3.783-7.293-8.028v-9.902c0-4.442 3.524-8.049 7.866-8.049h6.61zm34.09 18.566c2.004 0 3.632 1.666 3.632 3.717 0 2.052-1.628 3.717-3.632 3.717-2.005 0-3.633-1.665-3.633-3.717 0 2.052-1.627 3.717-3.632 3.717s-3.632-1.665-3.632-3.717c0-2.051 1.627-3.717 3.632-3.717 1.94 0 3.527 1.56 3.627 3.52l.005.185.005-.185c.1-1.96 1.688-3.52 3.628-3.52zm28.951 0c2.005 0 3.633 1.666 3.633 3.717 0 2.052-1.628 3.717-3.633 3.717-2.004 0-3.632-1.665-3.632-3.717 0 2.052-1.627 3.717-3.632 3.717s-3.632-1.665-3.632-3.717c0 2.052-1.628 3.717-3.633 3.717s-3.632-1.665-3.632-3.717c0-2.051 1.627-3.717 3.632-3.717 1.94 0 3.527 1.56 3.627 3.52l.005.185.006-.185c.1-1.96 1.687-3.52 3.627-3.52 1.94 0 3.527 1.56 3.627 3.52l.005.185.005-.185c.1-1.96 1.687-3.52 3.627-3.52zm-59.381-9.902c2.005 0 3.632 1.665 3.632 3.717 0 2.051-1.627 3.717-3.632 3.717s-3.632-1.666-3.632-3.717c0-2.052 1.627-3.717 3.632-3.717zM1181.57 767v17.151c0 4.417-3.525 8.003-7.866 8.003h-27.931c-2.424 0-4.85 1.496-4.85 3.962s1.968 4.468 4.392 4.468H1224c-.149.71-.814 1.368-1.267 1.416h-80.95c-3.192 0-5.783-2.637-5.783-5.884 0-3.248 2.591-5.885 5.783-5.885h7.061v-.003h20.057c3.296 0 5.973-2.723 5.973-6.077h.013V771.08c0-2.253 1.795-4.079 4.009-4.079h2.674zm9.608 0v17.151h.013c0 3.354 2.676 6.077 5.973 6.077h14.168c3.296 0 5.972-2.723 5.972-6.077 0-3.353-2.676-6.076-5.972-6.076h-2.5c-2.166.266-4.14 1.733-4.14 3.958 0 2.466 1.967 4.468 4.391 4.468h6.046c-.148.71-.814 1.368-1.267 1.416h-8.31c-3.192 0-5.784-2.637-5.784-5.884 0-3.122 2.395-5.68 5.416-5.873v-.012h10.95c4.342 0 7.866 3.586 7.866 8.003s-3.524 8.003-7.866 8.003h-23.773c-4.341 0-7.866-3.586-7.866-8.003V771.08c0-2.253 1.795-4.079 4.01-4.079h2.673zm16.007 0c2.004 0 3.632 1.656 3.632 3.696s-1.628 3.695-3.632 3.695c-2.005 0-3.633-1.656-3.633-3.695 0-2.04 1.628-3.696 3.633-3.696zm7.264 0c2.005 0 3.633 1.656 3.633 3.696s-1.628 3.695-3.633 3.695c-2.004 0-3.632-1.656-3.632-3.695 0-2.04 1.628-3.696 3.632-3.696z"
                            transform="translate(-1136 -767)"
                          />
                        </g>
                      </g>
                    </svg>
                  )}
                </div>
                <div
                  className="sliderBottomIconsBefore"
                  id="sliderBottomIconsBefore"
                  style={{ position: "relative" }}
                >
                  {sectionsData.slice(1, 6)?.map((section, index) => {
                    // if (section?.title) {
                    return (
                      <div
                        key={section?.title + index}
                        onClick={() => {
                          // myAnimation(0, activeTab, { title: undefined }, false);
                          contactUs
                            ? myAnimation(index + 2, activeTab, section, false)
                            : myAnimation(index + 2, activeTab, section, false);
                        }}
                        style={{
                          // marginRight:
                          //   index == 0
                          //     ? 0
                          //     : `${
                          //         ((document?.getElementById(
                          //           "sliderBottomIconsBefore"
                          //         )?.offsetWidth -
                          //           100) /
                          //           5) *
                          //         0.2
                          //       }px`,
                          // marginLeft:
                          //   index == 4
                          //     ? 0
                          //     : `${
                          //         ((document?.getElementById(
                          //           "sliderBottomIconsBefore"
                          //         )?.offsetWidth -
                          //           100) /
                          //           5) *
                          //         0.2
                          //       }px`,

                          height: "100%",
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          // border: "2px solid red",
                          // background:
                          //   activeSection?.title === section.title
                          //     ? `${section?.iconGradiant}`
                          //     : "",
                          padding: "15px 0px",
                          cursor: "pointer",
                          zIndex: 10000,
                        }}
                      >
                        <span
                          className="bottomIconsContainer"
                          style={{
                            height: "50px",
                            width: "50px",
                          }}
                        >
                          {section.svg}
                        </span>
                        <span
                          style={{
                            color: "#fff",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          {section.title}
                        </span>
                      </div>
                    );
                    // }
                  })}
                  <div
                    id="movingContainer"
                    style={{
                      borderRadius: "15px",
                      // height: "100px",
                      // width: "150px",
                      height: `${
                        document?.getElementById("sliderBottomIconsBefore")
                          ?.offsetHeight * 0.9
                      }px`,
                      width: `${
                        ((document?.getElementById("sliderBottomIconsBefore")
                          ?.offsetWidth -
                          100) /
                          5) *
                        0.8
                      }px`,
                      position: "absolute",
                      transform: `translateX(${0}px)`,
                      // background: `${sectionsData[0].iconGradiant}`,
                      // background:
                      //   activeTab != 0
                      //     ? `${sectionsData[activeTab].iconGradiant}`
                      //     : "",
                    }}
                  ></div>
                </div>

                <span
                  className="landingDots"
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    position: "absolute",
                    left: `${(window.innerWidth - 200) / 2}px`,
                  }}
                >
                  <span
                    style={{
                      height: "9px",
                      width: "25px",
                      borderRadius: "7px",
                      margin: "0px",
                      border: "1px solid #ffffff",
                      marginLeft: "15px",
                      backgroundColor: activeTab === 0 ? "#fff" : "transparent",
                    }}
                  ></span>
                  {[1, 2, 3, 4, 5].map((item) => (
                    <span
                      style={{
                        height: "8px",
                        width: "8px",
                        borderRadius: "50%",
                        border: "1px solid #fff",
                        margin: "0px 4px",
                        backgroundColor:
                          activeTab === item ? "#fff" : "transparent",
                      }}
                    ></span>
                  ))}
                </span>
                <div className="sliderBottomIconsAfter">
                  {sectionsData?.slice(1, 6).map((section, index) => {
                    return (
                      <Button
                        variant="outlined"
                        key={`a${index}`}
                        // onClick={() =>
                        //   myAnimation(index + 1, activeTab, section, false)
                        // }
                        onClick={() => {
                          setContactUs(false);
                          setActiveSection(section);
                          setActiveTab(index + 1);
                        }}
                        style={{
                          height: "100%",
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          border: "none",
                        }}
                      >
                        {activeSection.title === section.title
                          ? section.activeSvg
                          : section.svgRes}
                        <span
                          className={
                            activeLang?.abbreviation === "FA"
                              ? "sliderIconsAfterTitles"
                              : "sliderIconsAfterTitlesLangs"
                          }
                          style={{
                            color:
                              activeSection.title === section.title
                                ? section.color
                                : "#727d93",
                          }}
                        >
                          {" " + section.title + " "}
                        </span>
                      </Button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"bottomTape"}></div>
    </div>
  );
};

export default Landing;
